// import Swiper JS
// core version + navigation, pagination modules:
import Swiper from "swiper"
import {Navigation} from 'swiper/modules'
import {Pagination} from 'swiper/modules'
import {Autoplay} from 'swiper/modules'
import {EffectFade} from 'swiper/modules'
import SimpleLightbox from "simplelightbox";

import SimpleBar from 'simplebar';
import 'simplelightbox/dist/simple-lightbox.css';
import 'simplebar/dist/simplebar.css';
// import SlimSelect from 'slim-select'
// import 'slim-select/dist/slimselect.css';
// import TomSelect  from "tom-select";
// import select2  from "select2";
// import 'select2/dist/css/select2.min.css';

import 'choices.js/public/assets/styles/choices.min.css';
import Choices from 'choices.js';

// import Swiper styles
import 'swiper/css';



(function ($) {
    const tlang = getCurrentLanguage();
    console.log(tlang);
    // Obiekt z tłumaczeniami - dodaj tutaj swoje tłumaczenia
    const translations = {
        pl: {
            selectSize: 'Wybierz rozmiar',
            selectTest: 'Wybierz próbę',
            selectMeasureType: 'Wybierz rodzaj miarki',
            addToCart: 'Dodaj do koszyka',
            seeResults: 'Zobacz wyniki',
            noResults: 'Brak wyników',
            invalidPhoneNumber: 'Wprowadź poprawny numer telefonu (np. +48 123 456 789)',
            invalidEmail: 'Wprowadź poprawny adres email',
            size: 'Rozmiar',
            test: 'Próba',
            measureType: 'Rodzaj miarki'
        },
        en: {
            selectSize: 'Select size',
            selectTest: 'Select test',
            selectMeasureType: 'Select measure type',
            addToCart: 'Add to cart',
            seeResults: 'See results',
            noResults: 'No results',
            invalidPhoneNumber: 'Enter a valid phone number (e.g. +48 123 456 789)',
            invalidEmail: 'Enter a valid email address',
            size: 'Size',
            test: 'Test',
            measureType: 'Measure type'
        },
        de: {
            selectSize: 'Größe wählen',
            selectTest: 'Test wählen',
            selectMeasureType: 'Messart wählen',
            addToCart: 'In den Warenkorb',
            seeResults: 'Ergebnisse anzeigen',
            noResults: 'Keine Ergebnisse',
            invalidPhoneNumber: 'Geben Sie eine gültige Telefonnummer ein (z.B. +48 123 456 789)',
            invalidEmail: 'Geben Sie eine gültige E-Mail-Adresse ein',
            size: 'Größe',
            test: 'Test',
            measureType: 'Messart'
        }
    };

    // Funkcja do pobierania aktualnego języka - dostosuj do swojego systemu
    function getCurrentLanguage() {
        // Pobierz język z atrybutu html lang (np. 'pl-PL', 'en-US')
        let lang = document.documentElement.lang || 'pl-PL';

        // Konwertuj format pl-PL na pl, en-US na en, itp.
        return lang.split('-')[0].toLowerCase();
    }

    // Funkcja do pobierania tłumaczenia
    function __(key) {
        const lang = getCurrentLanguage();
        return translations[lang] && translations[lang][key] ? translations[lang][key] : translations.pl[key] || key;
    }
    const Sliders = {
        init() {
            // Initialize hero slider
            if (document.querySelector('.hero-slider__slider')) {
                const heroSwiper = new Swiper('.hero-slider__slider', {
                    modules: [Navigation],
                    speed: 400,
                    loop: true,
                    slidesPerView: 2.33,
                    spaceBetween: 20,
                    centeredSlides: true,
                    navigation: {
                        nextEl: '.hero-slider__slider .swiper-button-next',
                        prevEl: '.hero-slider__slider .swiper-button-prev',
                    },
                    scrollbar: {
                        el: '.hero-slider__slider .swiper-scrollbar',
                    },
                    breakpoints: {
                        320: { slidesPerView: 1 },
                        577: { slidesPerView: 1.66 },
                        768: { slidesPerView: 2.33 }
                    }
                });
            }
            // Initialize category slider
            if (document.querySelector('.category-slider__slider')) {
                const categorySwiper = new Swiper('.category-slider__slider', {
                    modules: [Navigation],
                    speed: 400,
                    loop: true,
                    slidesPerView: 2.33,
                    spaceBetween: 20,
                    centeredSlides: true,
                    navigation: {
                        nextEl: '.category-slider__slider .swiper-button-next',
                        prevEl: '.category-slider__slider .swiper-button-prev',
                    },
                    scrollbar: {
                        el: '.category-slider__slider .swiper-scrollbar',
                    },
                    breakpoints: {
                        320: { slidesPerView: 1 },
                        768: { slidesPerView: 2.33 }
                    }
                });
            }

            // Initialize quotes slider
            if (document.querySelector('.quotes-slider__slider')) {
                const quotesSlider = new Swiper('.quotes-slider__slider', {
                    modules: [Navigation, Pagination],
                    speed: 400,
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    navigation: {
                        nextEl: '.quotes-slider__slider .swiper-button-next',
                        prevEl: '.quotes-slider__slider .swiper-button-prev',
                    },
                    scrollbar: {
                        el: '.quotes-slider__slider .swiper-scrollbar',
                    },
                    breakpoints: {
                        320: {
                            navigation: { enabled: false },
                            pagination: {
                                el: '.quotes-slider__slider .swiper-pagination',
                                type: 'bullets',
                                clickable: true
                            },
                        },
                        768: {
                            navigation: { enabled: true }
                        }
                    }
                });
            }

            // Initialize product gallery
            if (document.querySelector('.product-gallery')) {
                // Twój istniejący kod Swiper (bez zmian)
                const singleProductSwiper = new Swiper('.product-gallery', {
                    loop: true,
                    autoplay: {
                        delay: 4000,
                        disableOnInteraction: true,
                    },
                    effect: 'fade',
                    speed: 2000,
                    fadeEffect: {
                        crossFade: true
                    },
                    modules: [Navigation, Pagination, Autoplay, EffectFade],
                    navigation: {
                        nextEl: '.product-gallery .swiper-button-next',
                        prevEl: '.product-gallery .swiper-button-prev',
                    },
                    pagination: {
                        el: '.product-gallery .swiper-pagination',
                        clickable: true,
                    }
                });

                // Cache dla obrazów wysokiej jakości
                const highResCache = {};

                // Wykrywanie urządzeń mobilnych
                const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

                // SVG ikony lupy do użycia na obrazkach
                const magnifierSvg = `
        <svg class="zoom-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36">
            <circle cx="10" cy="10" r="7" fill="none" stroke="white" stroke-width="2" stroke-opacity="0.8"/>
            <path d="M16 16 L21 21" stroke="white" stroke-width="2" stroke-linecap="round" stroke-opacity="0.8"/>
            <circle cx="10" cy="10" r="3" fill="rgba(255,255,255,0.3)"/>
        </svg>
    `;

                // Funkcja do przygotowania zoomu
                function prepareZoom() {
                    // console.log('Przygotowanie lupy...');

                    // Znajdź aktywny slajd i jego obrazek
                    const activeSlide = document.querySelector('.product-gallery .swiper-slide-active');
                    if (!activeSlide) return;

                    const img = activeSlide.querySelector('img');
                    if (!img) return;

                    // Pobierz URL obrazu wysokiej jakości
                    const highResUrl = img.getAttribute('data-zoom-image') || img.src;

                    // Preładuj obraz wysokiej jakości
                    if (!highResCache[highResUrl]) {
                        const preloader = new Image();
                        preloader.onload = function() {
                            highResCache[highResUrl] = true;
                            // console.log('Preładowano obraz wysokiej jakości:', highResUrl);
                        };
                        preloader.src = highResUrl;
                    }

                    // Oznacz slajd jako przygotowany do zoomu
                    activeSlide.classList.add('zoom-ready');

                    // Usuń poprzednie elementy zoomu i ikony
                    document.querySelectorAll('.magnifying-glass, .zoom-icon-container').forEach(el => {
                        el.remove();
                    });

                    // Dodaj kontener dla ikony lupy w prawym dolnym rogu
                    const iconContainer = document.createElement('div');
                    iconContainer.className = 'zoom-icon-container';
                    iconContainer.style.cssText = 'position:absolute;bottom:10px;right:10px;width:40px;height:40px;display:flex;align-items:center;justify-content:center;opacity:1;transition:opacity 0.2s ease;z-index:15;pointer-events:auto;';
                    iconContainer.innerHTML = magnifierSvg;
                    activeSlide.appendChild(iconContainer);

                    // Stwórz element lupy (ale jeszcze go nie pokazuj)
                    const magnifyingGlass = document.createElement('div');
                    magnifyingGlass.className = 'magnifying-glass';
                    magnifyingGlass.style.cssText = `
            position: absolute;
            width: 175px;
            height: 175px;
            border-radius: 50%;
            border: 2px solid #fff;
            box-shadow: 0 5px 15px rgba(0,0,0,0.3);
            background-repeat: no-repeat;
            background-size: ${img.width * 4}px ${img.height * 4}px;
            transform: translate(-50%, -50%);
            pointer-events: none;
            opacity: 0;
            z-index: 1000;
            display: none;
            background-image: url('${highResCache[highResUrl] ? highResUrl : highResUrl}');
        `;
                    activeSlide.appendChild(magnifyingGlass);

                    // Różne funkcje w zależności od typu urządzenia
                    if (isMobile) {
                        setupMobileMagnifyingGlass(activeSlide, img, highResUrl, iconContainer, magnifyingGlass);
                    } else {
                        setupDesktopMagnifyingGlass(activeSlide, img, highResUrl, iconContainer, magnifyingGlass);
                    }
                }

                // Konfiguracja lupy dla desktopa
                function setupDesktopMagnifyingGlass(activeSlide, img, highResUrl, iconContainer, magnifyingGlass) {
                    let isActive = false;

                    // Funkcja aktywująca lupę
                    function activateMagnifyingGlass(e) {
                        e.preventDefault();

                        // Jeśli lupa aktywna, aktualizuj jej pozycję
                        if (isActive) {
                            updateMagnifyingGlass(e);
                            return;
                        }

                        // Aktywuj lupę
                        // console.log('Aktywacja lupy na desktopie...');

                        // Ukryj ikonę lupy
                        iconContainer.style.opacity = '0';

                        // Pokaż lupę
                        magnifyingGlass.style.display = 'block';
                        setTimeout(() => {
                            magnifyingGlass.style.opacity = '1';
                        }, 50);

                        // Ustaw flagę
                        isActive = true;

                        // Zatrzymaj autoplay
                        if (singleProductSwiper.autoplay && singleProductSwiper.autoplay.running) {
                            singleProductSwiper.autoplay.stop();
                        }

                        // Wykonaj pierwszą aktualizację lupy
                        updateMagnifyingGlass(e);
                    }

                    // Funkcja aktualizująca pozycję lupy
                    function updateMagnifyingGlass(e) {
                        if (!isActive) return;

                        const rect = img.getBoundingClientRect();

                        // Oblicz pozycję kursora względem obrazka
                        const mouseX = e.clientX - rect.left;
                        const mouseY = e.clientY - rect.top;

                        // Ustaw pozycję lupy
                        magnifyingGlass.style.left = `${mouseX}px`;
                        magnifyingGlass.style.top = `${mouseY}px`;

                        // Oblicz pozycję tła (powiększonego obrazu) pod kursorem
                        const backgroundPosX = (mouseX / img.width) * 100;
                        const backgroundPosY = (mouseY / img.height) * 100;

                        // Ustaw pozycję tła
                        magnifyingGlass.style.backgroundPosition = `${backgroundPosX}% ${backgroundPosY}%`;
                    }

                    // Funkcja deaktywująca lupę
                    function deactivateMagnifyingGlass() {
                        if (!isActive) return;

                        // console.log('Deaktywacja lupy na desktopie...');

                        // Ukryj lupę
                        magnifyingGlass.style.opacity = '0';
                        setTimeout(() => {
                            magnifyingGlass.style.display = 'none';
                        }, 200);

                        // Pokaż ikonę lupy
                        iconContainer.style.opacity = '1';

                        // Zresetuj flagę
                        isActive = false;

                        // Wznów autoplay
                        if (singleProductSwiper.autoplay && !singleProductSwiper.autoplay.running) {
                            singleProductSwiper.autoplay.start();
                        }
                    }

                    // Dodaj obsługę zdarzeń
                    img.addEventListener('mouseenter', activateMagnifyingGlass);
                    img.addEventListener('mousemove', updateMagnifyingGlass);
                    img.addEventListener('mouseleave', deactivateMagnifyingGlass);

                    // Dodaj obsługę dla ikony lupy
                    iconContainer.addEventListener('click', function(e) {
                        e.stopPropagation();

                        // Przełącz stany - jeśli nie aktywny, aktywuj, w przeciwnym razie deaktywuj
                        if (!isActive) {
                            // Symuluj zdarzenie mouseenter na obrazku
                            const mouseEvent = new MouseEvent('mouseenter', {
                                view: window,
                                bubbles: true,
                                cancelable: true,
                                clientX: e.clientX,
                                clientY: e.clientY
                            });
                            img.dispatchEvent(mouseEvent);
                        } else {
                            deactivateMagnifyingGlass();
                        }
                    });
                }

                // Konfiguracja lupy dla urządzeń mobilnych
                function setupMobileMagnifyingGlass(activeSlide, img, highResUrl, iconContainer, magnifyingGlass) {
                    let isActive = false;

                    // Funkcja przełączająca lupę
                    function toggleMagnifyingGlass(e) {
                        e.preventDefault();
                        e.stopPropagation();

                        // Jeśli lupa jest aktywna, deaktywuj ją
                        if (isActive) {
                            // console.log('Deaktywacja lupy na mobile...');

                            // Ukryj lupę
                            magnifyingGlass.style.opacity = '0';
                            setTimeout(() => {
                                magnifyingGlass.style.display = 'none';
                            }, 200);

                            // Pokaż ikonę lupy
                            iconContainer.style.opacity = '1';

                            // Zresetuj flagę
                            isActive = false;

                            // Wznów autoplay i odblokuj slajder
                            if (singleProductSwiper.autoplay && !singleProductSwiper.autoplay.running) {
                                singleProductSwiper.autoplay.start();
                            }
                            singleProductSwiper.allowTouchMove = true;

                            // Usuń obsługę zdarzenia touchmove
                            img.removeEventListener('touchmove', updateMagnifyingGlass);
                            return;
                        }

                        // Aktywuj lupę
                        // console.log('Aktywacja lupy na mobile...');

                        // Ukryj ikonę lupy
                        iconContainer.style.opacity = '0';

                        // Pokaż lupę
                        magnifyingGlass.style.display = 'block';
                        setTimeout(() => {
                            magnifyingGlass.style.opacity = '1';
                        }, 50);

                        // Ustaw flagę
                        isActive = true;

                        // Zatrzymaj autoplay i zablokuj slajder
                        if (singleProductSwiper.autoplay && singleProductSwiper.autoplay.running) {
                            singleProductSwiper.autoplay.stop();
                        }
                        singleProductSwiper.allowTouchMove = false;

                        // Dodaj obsługę zdarzenia touchmove
                        img.addEventListener('touchmove', updateMagnifyingGlass);

                        // Aktualizuj lupę dla bieżącej pozycji
                        updateMagnifyingGlass(e);
                    }

                    // Funkcja aktualizująca pozycję lupy
                    function updateMagnifyingGlass(e) {
                        if (!isActive) return;

                        // Pobierz położenie dotyku
                        const touch = e.touches ? e.touches[0] : e;
                        const touchX = touch.clientX;
                        const touchY = touch.clientY;

                        const rect = img.getBoundingClientRect();

                        // Oblicz pozycję dotyku względem obrazka
                        const touchXRelative = touchX - rect.left;
                        const touchYRelative = touchY - rect.top;

                        // Zapobiegaj przesuwaniu strony podczas używania lupy
                        e.preventDefault();

                        // Sprawdź, czy dotyk jest w obrębie obrazka
                        if (touchXRelative >= 0 && touchXRelative <= rect.width &&
                            touchYRelative >= 0 && touchYRelative <= rect.height) {

                            // Ustaw pozycję lupy
                            magnifyingGlass.style.left = `${touchXRelative}px`;
                            magnifyingGlass.style.top = `${touchYRelative}px`;

                            // Oblicz pozycję tła (powiększonego obrazu) pod dotykiem
                            const backgroundPosX = (touchXRelative / img.width) * 100;
                            const backgroundPosY = (touchYRelative / img.height) * 100;

                            // Ustaw pozycję tła
                            magnifyingGlass.style.backgroundPosition = `${backgroundPosX}% ${backgroundPosY}%`;
                        } else {
                            // Jeśli dotyk wyszedł poza obrazek, deaktywuj lupę
                            toggleMagnifyingGlass(e);
                        }
                    }

                    // Dodaj obsługę zdarzenia kliknięcia na obrazek
                    img.addEventListener('click', toggleMagnifyingGlass);

                    // Dodaj obsługę kliknięcia na ikonę lupy
                    iconContainer.addEventListener('click', function(e) {
                        e.stopPropagation();
                        toggleMagnifyingGlass(e);
                    });
                }

                // Dodaj style CSS
                const style = document.createElement('style');
                style.textContent = `
        .product-gallery {
            overflow: hidden !important;
        }
        
        .product-gallery .swiper-wrapper {
            overflow: hidden !important;
        }
        
        .product-gallery .swiper-slide-active {
            z-index: 10;
        }
        
        .product-gallery .swiper-slide {
            position: relative;
        }
        
        /* Ikona lupy */
        .zoom-icon-container {
            cursor: pointer;
            background: transparent;
            border-radius: 50%;
            box-shadow: 0 2px 5px rgba(0,0,0,0.2);
            opacity: 0.8;
            transition: opacity 0.2s ease, transform 0.2s ease;
        }
        
        .zoom-icon-container:hover {
            opacity: 1;
            transform: scale(1.1);
        }
        
        .zoom-icon {
            filter: drop-shadow(0px 0px 2px rgba(0,0,0,0.5));
        }
        
        /* Lupa */
        .magnifying-glass {
            transition: opacity 0.2s ease;
        }
        
        /* Mobilne dostosowania */
        @media (max-width: 768px) {
            .zoom-icon-container {
                padding: 5px;
                background: rgba(255,255,255,0.7);
            }
            
            /* Większa lupa na urządzeniach mobilnych */
            .magnifying-glass {
                width: 180px !important;
                height: 180px !important;
            }
        }
    `;
                document.head.appendChild(style);

                // Funkcja do czyszczenia i ponownego przygotowania lupy
                function resetAndPrepareZoom() {
                    // console.log('Resetowanie i ponowne przygotowanie lupy...');

                    // Usuń wszystkie elementy
                    document.querySelectorAll('.magnifying-glass, .zoom-icon-container').forEach(el => {
                        el.remove();
                    });

                    // Usuń klasy i style ze wszystkich slajdów
                    document.querySelectorAll('.product-gallery .swiper-slide').forEach(slide => {
                        slide.classList.remove('zoom-ready');
                        const img = slide.querySelector('img');
                        if (img) {
                            // Klonowanie elementu, aby usunąć obsługiwane zdarzenia
                            const newImg = img.cloneNode(true);
                            img.parentNode.replaceChild(newImg, img);
                        }
                    });

                    // Odblokuj slajder na wszelki wypadek
                    singleProductSwiper.allowTouchMove = true;

                    // Przygotuj lupę na aktywnym slajdzie
                    prepareZoom();
                }

                // Inicjalizuj lupę po załadowaniu strony
                document.addEventListener('DOMContentLoaded', function() {
                    setTimeout(prepareZoom, 300);
                });

                // Dodatkowo inicjalizuj po pełnym załadowaniu
                window.addEventListener('load', function() {
                    prepareZoom();
                });

                // Reinicjalizuj lupę po zmianie slajdu
                singleProductSwiper.on('slideChangeTransitionEnd', function() {
                    console.log('Zmiana slajdu - ponowne przygotowanie lupy');
                    resetAndPrepareZoom();
                });
            }


            // Initialize product sliders
            const productSliders = document.querySelectorAll('.products__slider');
            if (productSliders.length > 0) {
                productSliders.forEach((swiperEl) => {
                    const productSwiper = new Swiper(swiperEl, {
                        loop: true,
                        modules: [Navigation],
                        speed: 400,
                        navigation: {
                            nextEl: swiperEl.querySelector('.swiper-button-next'),
                            prevEl: swiperEl.querySelector('.swiper-button-prev'),
                        },
                    });

                    function updateProductSwiper() {
                        const windowWidth = window.innerWidth;
                        productSwiper.params.slidesPerView = windowWidth <= 768 ? 2 : 4;
                        productSwiper.params.spaceBetween = 0;
                        productSwiper.params.slidesPerGroup = windowWidth <= 768 ? 2 : 1;
                        productSwiper.update();
                    }

                    updateProductSwiper();
                    window.addEventListener('resize', updateProductSwiper);
                });
            }









        }
    }
    const MenuNavbar = {
        lastScrollTopPosition: 0,
        clickedElementMenu: [],
        firstLevelWithDiv: false,
        init() {

            if (document.querySelector(".menu-toggler")) {
                $(".menu-toggler").on("click", this.handleMobiieMenuShow)
            }

            $('a.menu__link[href^="#"]').on('click', function(e){
                let anchor = $(this).attr('href');
                if(anchor !== '#') {
                    e.preventDefault();
                    let anchorEl = $(  anchor  ).offset().top ;
                    $('body').removeClass("nav-expanded");
                    $("html, body").animate({
                        scrollTop: anchorEl - 100
                    }, 1000);
                }
            });
            // $('.location__link a[href*="#"]').on('click', function(e){
            //     var hash = this.hash;
            //
            //     // Sprawdź czy link zawiera hash i czy element z tym ID istnieje na stronie
            //     if (hash !== '' && $(hash).length) {
            //         // Zatrzymaj domyślne zachowanie przeglądarki
            //         event.preventDefault();
            //
            //         // Pobierz pozycję elementu
            //         var targetPosition = $(hash).offset().top;
            //
            //         // Zastosuj ujemny offset 120px
            //         var scrollPosition = targetPosition - 200;
            //
            //         // Wykonaj płynne przewinięcie
            //         $('html, body').animate({
            //             scrollTop: scrollPosition
            //         }, 1000, function() {
            //             // Po zakończeniu animacji, dodaj hash do adresu URL
            //             window.location.hash = hash;
            //         });
            //     }
            // });

            // Obsługa przekierowania z hashem przy załadowaniu strony
            function handleHashScroll() {
                if (window.location.hash) {
                    var hash = window.location.hash;
                    var $target = $(hash);

                    if ($target.length) {
                        // Opóźnij scroll, aby strona zdążyła się w pełni załadować
                        setTimeout(function() {
                            var targetPosition = $target.offset().top;
                            var scrollPosition = targetPosition - 200; // Zastosuj offset 120px

                            $('html, body').animate({
                                scrollTop: scrollPosition
                            }, 800);
                        }, 300);
                    }
                }
            }

            // Wywołaj funkcję przy załadowaniu strony
            handleHashScroll();

            // Obsługa kliknięć na linkach z hashem
            $(document).on('click', '.location__link a[href*="#"]', function(event) {
                var href = this.href;
                var currentPageUrl = window.location.origin + window.location.pathname;
                var linkUrl = href.split('#')[0];
                var hash = this.hash;

                // Jeśli link prowadzi do tej samej strony (tylko inny hash)
                if (linkUrl === currentPageUrl || linkUrl === '' || linkUrl === window.location.origin + '/' || !linkUrl) {
                    if (hash && $(hash).length) {
                        event.preventDefault();

                        var targetPosition = $(hash).offset().top;
                        var scrollPosition = targetPosition - 200; // Zastosuj offset 120px

                        $('html, body').animate({
                            scrollTop: scrollPosition
                        }, 800, function() {
                            window.location.hash = hash;
                        });
                    }
                }
                // Jeśli link prowadzi do innej strony z hashem, dopiszmy parametr do URL
                else if (hash) {
                    // Dodaj parametr do URL, który zostanie odczytany po przekierowaniu
                    // this.href = href + '&scrollOffset=120';
                }
            });

            // Obsługa parametru scrollOffset w URL
            function getParameterByName(name) {
                var url = window.location.href;
                name = name.replace(/[\[\]]/g, '\\$&');
                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            }

            // Jeśli URL zawiera parametr scrollOffset, zastosuj go
            var scrollOffset = getParameterByName('scrollOffset');
            if (scrollOffset && window.location.hash) {
                var offsetValue = parseInt(scrollOffset);
                var hash = window.location.hash;
                var $target = $(hash);

                if ($target.length && !isNaN(offsetValue)) {
                    setTimeout(function() {
                        var targetPosition = $target.offset().top;
                        var scrollPosition = targetPosition - offsetValue;

                        $('html, body').animate({
                            scrollTop: scrollPosition
                        }, 800);

                        // Usuń parametr z URL, zachowując hash
                        var cleanUrl = window.location.href.replace(/[?&]scrollOffset=\d+/, '');
                        window.history.replaceState({}, document.title, cleanUrl);
                    }, 300);
                }
            }

            if($(window).width() > 767) {

                $('.menu__link.has-megamenu').on('mouseenter', function(){
                    // $('html,body').addClass('megamenu-active');
                    // $('html').css('margin-right', scrollWidth);
                    $(this).addClass('megamenu-link-active');
                    $(this).next().addClass('megamenu-active');

                    // $('.main-header').css('padding-right', headerRightPadding);
                });
                $('.menu__link:not(.has-megamenu)').on('mouseenter', function(){
                    $('.megamenu').removeClass('megamenu-active');
                    // $('html').css('margin-right', '');
                    // $('.main-header').css('margin-right', '0');
                    // $('.main-header').css('padding-right', '');
                });
                //   $('.menu__link.has-megamenu > .megamenu').on('mouseenter', function(){
                //     $('html,body').addClass('megamenu-active');
                //   });
                $('.main-header').on('mouseleave', function(){
                    $('.megamenu').removeClass('megamenu-active');
                    // $('html').css('margin-right', '');
                    // $('.main-header').removeAttr('style');
                    $('body').removeClass('nav-expanded');
                });
                $('.storefront-primary-navigation').on('mouseleave', function(){
                    // $('.megamenu').removeClass('megamenu-active');
                    // $('body').removeClass('nav-expanded');
                    // $('html').css('margin-right', '');
                    // $('.main-header').removeAttr('style');
                    // console.log('primary leave');
                });
            }
            else {
                $('.menu__link.has-megamenu').on('click', function(){
                    // $('html,body').addClass('megamenu-active');
                    // $('html').css('margin-right', scrollWidth);
                    $(this).next().toggleClass('megamenu-active');
                    $(this).addClass('hidden');

                    // $('.main-header').css('padding-right', headerRightPadding);
                });
                $('.megamenu__title').on('click', function(){
                    $(this).parent().siblings().find('.megamenu__list-col').removeClass('active');
                    $(this).parent().siblings().removeClass('column-active');
                    $(this).parent().toggleClass('column-active');
                    $(this).next().toggleClass('active');
                    let anchorEl = $( this  ).offset().top;
                    // console.log(anchorEl);
                    // const targetNextSection = $('.section-text_image--hero').next().offset().top - 250;
                    $("html, body").animate({
                        scrollTop: anchorEl
                    }, 200);
                });

                $('a.menu-heading').on('click', function(){
                    $(this).parent().parent().parent().removeClass('column-active');
                });

            }


        },
        handleMobiieMenuShow() {
            document.body.classList.toggle("nav-expanded");
            $('.site-search').fadeToggle(200);
            // $('.secondary-navigation').fadeToggle();
            // $('.main-header__search-form').removeClass('active');

        },

    }
    const Forms = {
        // initbeforeOptimize() {
        //     // $('.form-wrap :input').each(function() {
        //     //     var $input = $(this);
        //     //     var $row   = $input.closest('.form-wrap');
        //     //     // Is the field filled on page load?
        //     //     if ($input.val() !== '') {
        //     //         console.log('input'+$input.attr('type')+' val['+$input.val()+']');
        //     //
        //     //         $row.addClass('-filled');
        //     //     }
        //     //
        //     //     // Enter or leave the "focus" state.
        //     //     $input.on('focus', function() {
        //     //         $row.addClass('-focus');
        //     //     });
        //     //     $input.on('blur', function() {
        //     //         $row.removeClass('-focus');
        //     //     });
        //     //
        //     //     // When the fields input value changes, add or remove the "-filled" state
        //     //     $input.on('input', function() {
        //     //         if ($input.val() !== '') {
        //     //             $row.addClass('-filled');
        //     //         } else {
        //     //             $row.removeClass('-filled');
        //     //         }
        //     //     });
        //     // })
        //
        //     // Obiekt przechowujący instancje Choices.js dla każdego selecta na podstawie atrybutu name
        //     var choicesInstances = {};
        //
        //
        //
        //
        //     //variation script  - click on vartion list item
        //
        //
        //     // Inicjalizacja instancji Choices.js dla pola product-size
        //     var productSizeSelect = document.querySelector('select[name="product-size"]');
        //     var productColorSelect = document.querySelector('select[name="product-color"]');
        //
        //     // Inicjalizacja Choices.js
        //     var productSizeInstance = new Choices(productSizeSelect);
        //     var productColorInstance = new Choices(productColorSelect);
        //
        //     // Zapisanie instancji w obiekcie, aby można było z nich korzystać później
        //     var choicesInstances = {
        //         'product-size': productSizeInstance,
        //         'product-color': productColorInstance
        //     };
        //
        //     //warianty - w widoku pojedynczego produktu
        //     $('.custom-variation-list').on('click', '.variation-list-item', function() {
        //         var variationId = $(this).data('variation_id');
        //         var originalValue = $(this).find('.size').attr('data-size');  // Pobranie oryginalnego rozmiaru
        //
        //         var colorValue = $('.product-color-value').text();
        //
        //         var product_title = $('.product_title').text();
        //         // Ustawienie wartości dla wariantu w formularzu
        //
        //         $('input[name="variation_id"]').val(variationId);
        //         // Zmiana klasy aktywnego elementu
        //         $('.custom-variation-list .variation-list-item').removeClass('active');
        //
        //         $(this).addClass('active');
        //         // Aktualizacja domyślnego dropdownu
        //
        //         $('select[name="attribute_pa_rozmiar"]').val(originalValue).trigger('change');
        //         // Odblokowanie przycisku dodaj do koszyka
        //         $('.single_add_to_cart_button').removeAttr('disabled');
        //         $('.custom-variation-wrapper').removeClass('active');
        //         $('.custom-variation-wrapper').addClass('focus');
        //         $('.custom-variation-button .value').html($(this).html());
        //
        //         // Aktualizacja atrybutów przycisku custom-extra-btn
        //         $('.custom-extra-btn').attr('data-product-title', product_title );
        //         if(originalValue) {
        //             $('.custom-extra-btn').attr('data-product-size', originalValue);
        //         }
        //         if(colorValue) {
        //             $('.custom-extra-btn').attr('data-product-color', colorValue);
        //         }
        //
        //         // Użycie Choices.js do zmiany wartości w select[name="product-size"]
        //         var productSizeInstance = choicesInstances['product-size'];
        //         if (productSizeInstance && originalValue) {
        //             productSizeInstance.setChoiceByValue(originalValue);
        //             console.log('Zmieniono rozmiar w Choices.js na:', originalValue);
        //         }
        //
        //         // console.log(sst);
        //         if($(this).find('.amount').length > 0) {
        //
        //             $('.single_add_to_cart_button').show();
        //             $('.custom-extra-btn').removeClass('active');
        //         }
        //         else {
        //             if($(this).find('.stock-status-text').text() !== '') {
        //                 $('.single_add_to_cart_button').hide();
        //                 $('.custom-extra-btn').addClass('active');
        //             }
        //         }
        //
        //
        //     });
        //     // Obsługa kliknięcia poza .custom-variation-wrapper, aby zamknąć listę
        //     $(document).on('click', function(event) {
        //         // Sprawdź, czy kliknięto poza elementem .custom-variation-wrapper
        //         if (!$(event.target).closest('.custom-variation-wrapper').length) {
        //             // Ukryj listę, jeśli kliknięto poza nią
        //             // $('.custom-variation-list').slideUp(); // Użycie animacji slideUp do zamknięcia listy
        //             $('.custom-variation-wrapper').removeClass('active');
        //         }
        //     });
        //
        //     // Obsługa otwierania listy przy kliknięciu na przycisk
        //     $('.custom-variation-button').on('click', function(e) {
        //         e.preventDefault();
        //         // Przełącz widoczność listy (pokazanie/ukrycie)
        //         // $('.custom-variation-list').slideToggle(); // Użycie slideToggle() dla efektu
        //     });
        //
        //
        //
        //
        //
        //
        //
        //
        //
        //
        //
        //
        //
        //     // Iteracja po każdym elemencie select z klasą custom-select
        //     $('.custom-select').each(function() {
        //         var element = this;
        //         var selectName = $(this).attr('name');  // Get the value from the name attribute
        //
        //         // Check if name exists
        //         if (!selectName) {
        //             console.error('Brak atrybutu name dla selecta', element);
        //             return;  // Skip to the next select if no name attribute
        //         }
        //
        //         // Initialize Choices.js for each select
        //         var choices = new Choices(element, {
        //             searchEnabled: false,  // Disable search
        //             itemSelectText: '',    // Remove "click to select" text
        //         });
        //
        //         // Listen to the 'change' event on the element
        //         element.addEventListener('change', function(event) {
        //             // Get the selected value and label
        //             var selectedValue = event.target.value;
        //             var selectedLabel = event.target.options[event.target.selectedIndex].text;
        //             var parentContainer = $(element).closest('.form-label');
        //             console.log('parent:', JSON.stringify(element));
        //             $(element).closest('.form-wrap-first-last').find('.form-label').removeClass('hidden');
        //             // alert(element.value);
        //
        //             // console.table('element'+$(element)[0]);
        //             // console.table('element'+parentContainer[0]);
        //             // parentContainer.removeClass('hidden');
        //             // parentContainer.addClass('REEEEEEEEEEEEEEEEED');
        //
        //             console.log('Selected Value:', selectedValue);
        //             console.log('Selected Label:', selectedLabel);
        //         });
        //
        //         // Store the Choices.js instance for each element in an object with the name as the key
        //         choicesInstances[selectName] = choices;
        //     });
        //     // console.log(choicesInstances);
        //     // Reinicjalizacja Choices.js po przesłaniu formularza WPCF7
        //     document.addEventListener('wpcf7submit', function(event) {
        //         $('.custom-select').each(function() {
        //             new Choices(this, {
        //                 searchEnabled: false,
        //                 itemSelectText: '',
        //             });
        //         });
        //     });
        //
        //     $('.woocommerce-variation-add-to-cart').on('click', '.custom-extra-btn', function() {
        //         // Zbieramy wartości z przycisku na podstawie atrybutów data-product-size i data-product-color
        //         var sizeValue = $(this).data('product-size');
        //         var colorValue = $(this).data('product-color');
        //         var productTitle = $(this).data('product-title');
        //
        //         // Tworzymy obiekt z nowymi wartościami, które chcemy ustawić
        //         var newValues = {
        //             'product-size': sizeValue,
        //             'product-color': colorValue
        //         };
        //
        //         // Iterujemy po newValues i ustawiamy wartości w odpowiednich instancjach Choices.js
        //         $.each(newValues, function(selectName, value) {
        //             if (choicesInstances[selectName]) {
        //                 var instance = choicesInstances[selectName];
        //                 console.table('instance'+instance);
        //
        //                 // Sprawdzamy bieżącą wybraną wartość
        //                 var currentValue = $(instance.passedElement.element).val();
        //
        //                 // Sprawdzamy, czy podana wartość jest już wybrana
        //                 // if (currentValue === value) {
        //                 //     console.log('Wartość ' + value + ' jest już wybrana w select', selectName);
        //                 //     return;  // Nie wykonujemy żadnych zmian, jeśli wartość jest już wybrana
        //                 // }
        //
        //                 // Sprawdzamy, czy podana wartość istnieje w opcjach selecta
        //                 var options = $(instance.passedElement.element).find('option[value="' + value + '"]');
        //                 if (options.length > 0) {
        //                     // Jeśli opcja istnieje, ustawiamy wartość w Choices.js
        //                     instance.setChoiceByValue(value);
        //
        //                     // Odświeżamy interfejs Choices.js, aby zmiana była widoczna
        //                     instance._addChoice({
        //                         value: value,
        //                         label: value,
        //                         selected: true,  // Oznaczamy jako wybraną
        //                         disabled: false
        //                     });
        //                     $(instance.passedElement.element).val(value).trigger('change');
        //
        //                     console.log('Zmieniono wartość w', selectName, 'na', value);
        //                     $('.form-label--'+selectName).removeClass('hidden');
        //                     if(value == '750') {
        //                          //zmień kolor złota na Białe złoto
        //                         console.log('750');
        //                     }
        //                     if(value == 'Białe złoto') {
        //                         //zmień próbę złota na 750
        //                     }
        //                 } else {
        //                     console.error('Wartość ' + value + ' nie istnieje w select', selectName);
        //                 }
        //             } else {
        //                 console.error('Nie znaleziono instancji dla selecta o name:', selectName);
        //             }
        //         });
        //
        //         $('.form-label--product-parameters span').html(productTitle);
        //        $('.panel-sidebar').addClass('active');
        //         // $('.custom-select').val(dataSize);
        //     });
        //
        //
        //
        //     // const choicesElement2 = document.querySelector('.choices-select');
        //     document.addEventListener('DOMContentLoaded', function () {
        //         // Zmiana select na Choices.js
        //         const element = document.querySelector('.choices-select');
        //         if(element) {
        //
        //             const choices = new Choices(element, {
        //                 searchEnabled: false, // Wyłącza wyszukiwanie
        //                 itemSelectText: '', // Usuwa domyślny tekst wyboru
        //                 shouldSort: false, // Nie sortuje opcji automatycznie
        //                 // callbackOnCreateTemplates: function (template) {
        //                 //     return {
        //                 //         choice: function (classNames, data) {
        //                 //             let fontFamily = data.element.dataset.font; // Pobranie kroju pisma z atrybutu data-font
        //                 //             return template(`
        //                 //     <div class="${classNames.item} ${classNames.itemChoice}" data-id="${data.id}" data-value="${data.value}" role="option" style="font-family: ${fontFamily};">
        //                 //         ${data.label}
        //                 //     </div>
        //                 // `);
        //                 //         }
        //                 //     };
        //                 // }
        //             });
        //         }
        //
        //         // Pokazywanie/ukrywanie opcji grawerowania po zaznaczeniu checkboxa
        //         // const graweringCheckbox = document.getElementById('add_grawering');
        //         // const graweringOptions = document.getElementById('grawering-options');
        //         //
        //         // if (graweringCheckbox) {
        //         //     graweringCheckbox.addEventListener('change', function () {
        //         //         if (this.checked) {
        //         //             graweringOptions.style.display = 'block';
        //         //         } else {
        //         //             graweringOptions.style.display = 'none';
        //         //         }
        //         //     });
        //         // }
        //
        //
        //
        //         // Inicjalizacja Choices.js po załadowaniu strony
        //         document.addEventListener('DOMContentLoaded', function () {
        //             const element = document.querySelector('.choices-select');
        //             const choices = new Choices(element, {
        //                 searchEnabled: false, // Wyłącza wyszukiwanie w select
        //                 itemSelectText: '', // Usuwa domyślny tekst wyboru
        //                 shouldSort: false, // Nie sortuje opcji automatycznie
        //                 callbackOnCreateTemplates: function (template) {
        //                     return {
        //                         choice: function (classNames, data) {
        //                             let fontFamily = data.element.dataset.font; // Pobranie kroju pisma z atrybutu data-font
        //                             return template(`
        //                     <div class="${classNames.item} ${classNames.itemChoice}" data-id="${data.id}" data-value="${data.value}" role="option" style="font-family: ${fontFamily};">
        //                         ${data.label}
        //                     </div>
        //                 `);
        //                         }
        //                     };
        //                 }
        //             });
        //         });
        //     });
        //
        //
        // },

        init() {
            // Obiekt przechowujący instancje Choices.js dla każdego selecta na podstawie atrybutu name
            var choicesInstances = {};

            // Funkcja do inicjalizacji Choices.js dla selectów z klasą custom-select
            function initializeChoicesForSelects() {
                $('.custom-select').each(function() {
                    var element = this;
                    var selectName = $(element).attr('name'); // Pobierz atrybut name selecta

                    // Sprawdź, czy instancja Choices.js już istnieje
                    if (!choicesInstances[selectName]) {
                        // Inicjalizuj Choices.js tylko raz
                        var choices = new Choices(element, {
                            searchEnabled: false,  // Wyłącza wyszukiwanie
                            itemSelectText: ''    // Usuwa domyślny tekst wyboru

                        });
                        choices.passedElement.element.addEventListener('change', function(event) {
                            let selectedValue = event.target.value;
                            // console.log(selectedValue);
                            $('#grawering_text').attr('data-font',selectedValue);
                        });

                        choicesInstances[selectName] = choices;

                    }
                });
            }


            function updateGoldTest() {
                const colorSelect = document.querySelector('[name="product-color1"]'); // lub twoja nazwa
                const goldTestSelect = document.querySelector('[name="product-gold-test1"]'); // lub twoja nazwa

                if (!colorSelect || !goldTestSelect) return;

                const selectedColor = colorSelect.value;

                if (selectedColor === 'Białe złoto') {
                    goldTestSelect.value = '750';

                    Array.from(goldTestSelect.options).forEach(option => {
                        if (option.value === '') {
                            option.style.display = 'none';
                            option.disabled = true;
                        } else if (option.value !== '750') {
                            option.style.display = 'none';
                            option.disabled = true;
                        } else {
                            option.style.display = 'block';
                            option.disabled = false;
                            option.selected = true;
                        }
                    });

                } else {
                    goldTestSelect.value = '';

                    Array.from(goldTestSelect.options).forEach(option => {
                        option.style.display = 'block';
                        option.disabled = false;
                        option.selected = (option.value === '');
                    });
                }

                $(goldTestSelect).removeClass('wpcf7-not-valid');
                $(goldTestSelect).closest('.wpcf7-form-control-wrap').removeClass('wpcf7-not-valid');
                $(goldTestSelect).closest('.wpcf7-form-control-wrap').find('.wpcf7-not-valid-tip').remove();

                goldTestSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }

            function initCustomSelects() {
                const colorSelect = document.querySelector('[name="product-color1"]');
                const goldTestSelect = document.querySelector('[name="product-gold-test1"]');



                if (colorSelect && goldTestSelect) {

                    if (colorSelect) {
                        colorSelect.classList.add('custom-select0');
                        wrapInCustomDiv(colorSelect);
                    }

                    if (goldTestSelect) {
                        goldTestSelect.classList.add('custom-select0');
                        wrapInCustomDiv(goldTestSelect);
                    }

                    function updateGoldTest() {
                        const selectedColor = colorSelect.value;

                        if (selectedColor === 'Białe złoto') {
                            // Białe złoto - tylko 750
                            goldTestSelect.value = '750';

                            Array.from(goldTestSelect.options).forEach(option => {
                                if (option.value === '') {
                                    // Ukryj "Wybierz próbę" gdy białe złoto
                                    option.style.display = 'none';
                                    option.disabled = true;
                                } else if (option.value !== '750') {
                                    // Ukryj inne opcje oprócz 750
                                    option.style.display = 'none';
                                    option.disabled = true;
                                } else {
                                    // Pokaż tylko 750
                                    option.style.display = 'block';
                                    option.disabled = false;
                                    option.selected = true; // Wymuś zaznaczenie
                                }
                            });

                        } else {
                            // Inne kolory - pokaż wszystkie opcje
                            goldTestSelect.value = '';

                            Array.from(goldTestSelect.options).forEach(option => {
                                option.style.display = 'block';
                                option.disabled = false;
                                option.selected = (option.value === ''); // Zaznacz "Wybierz próbę"
                            });
                        }

                        // Usuń błędy walidacji
                        $(goldTestSelect).removeClass('wpcf7-not-valid');
                        $(goldTestSelect).closest('.wpcf7-form-control-wrap').removeClass('wpcf7-not-valid');
                        $(goldTestSelect).closest('.wpcf7-form-control-wrap').find('.wpcf7-not-valid-tip').remove();

                        goldTestSelect.dispatchEvent(new Event('change', { bubbles: true }));
                    }

                    colorSelect.addEventListener('change', updateGoldTest);

                    // Sprawdź stan początkowy - WAŻNE!
                    updateGoldTest();
                }
            }
            function wrapInCustomDiv(select) {
                if (!select.parentNode.classList.contains('custom-select-wrapper')) {
                    const wrapper = document.createElement('div');
                    wrapper.className = 'custom-select-wrapper';
                    select.parentNode.insertBefore(wrapper, select);
                    wrapper.appendChild(select);
                }
            }
            initCustomSelects();
            // Wywołaj funkcję inicjalizującą Choices.js
            initializeChoicesForSelects();

            // Obsługa kliknięcia na listę wariantów
            $('.custom-variation-list').on('click', '.variation-list-item', function() {
                var variationId = $(this).data('variation_id');
                var originalValueSize = $(this).find('.size').attr('data-size');  // Pobranie oryginalnego rozmiaru
                var originalValueGoldTest = $(this).find('.gold-test').attr('data-gold-test');  // Pobranie oryginalnego rozmiaru
                var originalValueMeasure = $(this).find('.measure').attr('data-measure');
                var colorValue = $('.product-color-value').text();
                var productTitle = $('.product_title').text();
                // console.log(originalValueGoldTest);
                // console.log('colorValue'+colorValue);
                if(originalValueSize == 'twoj-rozmiar' || originalValueSize == 'inny' || originalValueSize == 'proba') {
                    $('.col-right .badge-available').addClass('d-none');
                }
                else {
                    $('.col-right .badge-available').removeClass('d-none');
                }

                if($('.panel-sidebar').hasClass('active')) {
                    setTimeout(function() {
                        // $('.wpcf7-form-control[name="product-size"]').val(originalValueSize);
                    }, 100);
                }

                // Ustawienie wartości dla wariantu w formularzu
                $('input[name="variation_id"]').val(variationId);
                $('.variation-description div').removeClass('active');
                $('.variation-description div[data-variation_id='+variationId+']').addClass('active');

                // Zmiana klasy aktywnego elementu
                $('.custom-variation-list .variation-list-item').removeClass('active');
                $(this).addClass('active');

                // Aktualizacja domyślnego dropdownu
                $('select[name="attribute_pa_rozmiar"]').val(originalValueSize).trigger('change');
                $('select[name="attribute_pa_proba"]').val(originalValueGoldTest).trigger('change');
                $('select[name="attribute_pa_rodzaj-miarki"]').val(originalValueMeasure).trigger('change');

                // Odblokowanie przycisku dodaj do koszyka
                $('.single_add_to_cart_button').removeAttr('disabled');
                $('.custom-variation-wrapper').removeClass('active').addClass('focus');
                $('.custom-variation-button .value').html($(this).html());

                // Aktualizacja atrybutów przycisku custom-extra-btn
                $('.custom-extra-btn').attr('data-product-title', productTitle);
                if (originalValueSize) {
                    $('.custom-extra-btn').attr('data-product-size', originalValueSize);
                    // $('input[name="product-size"]').val(originalValueSize);
                }
                if (originalValueGoldTest) {
                    $('.custom-extra-btn').attr('data-gold-test', originalValueGoldTest);
                    $('input[name="product-gold-test"]').val(originalValueGoldTest);
                }
                if (colorValue) {
                    $('.custom-extra-btn').attr('data-product-color', colorValue);
                }
                // $('input[name="product-size"]').val(originalValueSize);
                $('input[name="product-gold-test"]').val(originalValueGoldTest);

                // Użycie Choices.js do zmiany wartości w select[name="product-size"]
                // var productSizeInstance = choicesInstances['product-size'];
                // if (productSizeInstance && originalValue) {
                //     productSizeInstance.setChoiceByValue(originalValue);
                //     console.log('Zmieniono rozmiar w Choices.js na:', originalValue);
                // }

                // Obsługa widoczności przycisków
                if ($(this).find('.amount').length > 0) {
                    $('.single_add_to_cart_button').show();
                    $('.custom-extra-btn').removeClass('active');
                } else {
                    if ($(this).find('.stock-status-text').text() !== '') {
                        $('.single_add_to_cart_button').hide();
                        $('.custom-extra-btn').addClass('active');
                    }
                }
            });

            // Obsługa kliknięcia poza .custom-variation-wrapper, aby zamknąć listę
            $(document).on('click', function(event) {
                if (!$(event.target).closest('.custom-variation-wrapper').length) {
                    $('.custom-variation-wrapper').removeClass('active');
                }
            });

            // Obsługa otwierania listy przy kliknięciu na przycisk
            if($('.custom-variation-button').length > 0) {

                $('.custom-variation-button').on('click', function(e) {
                    e.preventDefault();
                });
            }
            if($('.grouped_form').length > 0 ) {
                var productTitle = $('.product_title').text();
                var goldColor = $('.product-color-value').text();
                $('.custom-extra-btn').attr('data-product-title', productTitle);
                $('.custom-extra-btn').attr('data-product-color', goldColor);

            }

            // Selecty rozmiaru dla każdego produktu w zestawie (produkt grupowy)
            if ($('.grouped-variation-select').length > 0) {
                $('.grouped_form .single_add_to_cart_button').prop('disabled', true);

                function updateGroupedTotalPrice() {
                    var $button = $('.grouped_form .single_add_to_cart_button');
                    var symbol = $button.attr('data-currency-symbol') || '';
                    var total = 0;

                    $('.grouped_form tr.woocommerce-grouped-product-list-item').each(function() {
                        var $row = $(this);
                        var $select = $row.find('.grouped-variation-select');

                        if ($select.length > 0) {
                            var price = parseFloat($select.find('option:selected').attr('data-price'));
                            if (!isNaN(price)) {
                                total += price;
                            }
                        } else {
                            var basePrice = parseFloat($row.attr('data-base-price'));
                            if (!isNaN(basePrice)) {
                                total += basePrice;
                            }
                        }
                    });

                    if (total > 0) {
                        $button.find('.grouped-total-price').text('(' + total.toFixed(2).replace('.', ',') + ' ' + symbol + ')');
                    } else {
                        $button.find('.grouped-total-price').text('');
                    }
                }

                updateGroupedTotalPrice();

                $(document).on('change', '.grouped-variation-select', function() {
                    var $select = $(this);
                    var $row = $select.closest('tr');
                    var variationId = $select.val();

                    $row.find('.grouped-variation-id').val(variationId);
                    $row.find('.grouped-variation-quantity').val(variationId ? 1 : '');

                    var allSelected = true;
                    $('.grouped-variation-select').each(function() {
                        if (!$(this).val()) {
                            allSelected = false;
                        }
                    });
                    $('.grouped_form .single_add_to_cart_button').prop('disabled', !allSelected);

                    updateGroupedTotalPrice();
                });
            }

            function initChoicesListeners0000() {
                const goldRules = {
                    tests: {
                        '750': 'Białe złoto'
                    },
                    colors: {
                        'Białe złoto': '750'
                    }
                };

                // Nasłuchiwacz dla koloru złota
                const colorSelect = document.querySelector('.panel-sidebar [name="product-color"]');
                if (colorSelect && choicesInstances['product-color']) {
                    colorSelect.addEventListener('change', function(event) {
                        const selectedValue = event.target.value;
                        const goldTestInstance = choicesInstances['product-gold-test'];
                        const goldSelect = document.querySelector('.panel-sidebar [name="product-gold-test"]');

                        if (goldTestInstance && goldSelect) {
                            if (selectedValue === 'Białe złoto') {
                                goldTestInstance.setChoiceByValue('750');
                                goldSelect.value = '750';
                                goldSelect.dispatchEvent(new Event('input')); // TYLKO ten event dodajemy
                                goldTestInstance.disable();
                                $('input[name="product-gold-test"]').val('750');
                            } else {
                                goldTestInstance.enable();
                                // $('input[name="white-gold-test"]').val('');
                            }
                        }
                    });
                }

                // Nasłuchiwacz dla próby złota
                const goldTestSelect = document.querySelector('.panel-sidebar [name="product-gold-test"]');
                if (goldTestSelect && choicesInstances['product-gold-test']) {
                    goldTestSelect.addEventListener('change', function(event) {
                        const selectedValue = event.target.value;
                        if (selectedValue === '750') {
                            const colorInstance = choicesInstances['product-color'];
                            if (colorInstance) {
                                colorInstance.setChoiceByValue('Białe złoto');
                            }
                        }
                    });
                }
            }

            function initChoicesListeners() {
                const goldRules = {
                    tests: {
                        '750': 'Białe złoto'
                    },
                    colors: {
                        'Białe złoto': '750'
                    }
                };

                // Walidacja początkowa
                function validateInitialState() {
                    const colorInstance = choicesInstances['product-color'];
                    const goldTestInstance = choicesInstances['product-gold-test'];

                    if (colorInstance && goldTestInstance) {
                        const selectedColor = colorInstance.getValue(true);
                        const selectedTest = goldTestInstance.getValue(true);

                        if (selectedColor === 'Białe złoto' && selectedTest !== '750') {
                            goldTestInstance.setChoiceByValue('750');
                            $('input[name="white-gold-test"]').val('750');
                            $('select[name="product-gold-test"]').val('750').trigger('change');
                            goldTestInstance.disable();
                        }

                        if (selectedTest === '750' && selectedColor !== 'Białe złoto') {
                            colorInstance.setChoiceByValue('Białe złoto');
                        }
                    }
                }

                // Wywołaj walidację po załadowaniu strony
                document.addEventListener('DOMContentLoaded', validateInitialState);
                // Dla przypadku gdy skrypt ładuje się po DOMContentLoaded
                validateInitialState();

                // Nasłuchiwacz dla koloru złota
                const colorSelect = document.querySelector('.panel-sidebar [name="product-color"]');
                if (colorSelect && choicesInstances['product-color']) {
                    colorSelect.addEventListener('change', function (event) {
                        const selectedValue = event.target.value;
                        const goldTestInstance = choicesInstances['product-gold-test'];
                        const goldSelect = document.querySelector('.panel-sidebar [name="product-gold-test"]');

                        if (goldTestInstance && goldSelect) {
                            if (selectedValue === 'Białe złoto') {
                                // Zaktualizuj wybór w Choices.js
                                goldTestInstance.setChoiceByValue('750');

                                // Wymuś aktualizację rzeczywistego <select>
                                goldSelect.value = '750';
                                $('select[name="product-gold-test"]').val('750').trigger('change');
                                $('input[name="white-gold-test"]').val('750');
                                // Wywołaj zdarzenie 'change' dla WPCF7
                                // goldSelect.dispatchEvent(new Event('change', { bubbles: true }));

                                // Zablokuj pole próby złota
                                goldTestInstance.disable();
                            } else {
                                // Odblokuj pole próby złota
                                $('input[name="white-gold-test"]').val('');
                                goldTestInstance.enable();
                            }
                        }
                    });
                }

                // Nasłuchiwacz dla próby złota
                const goldTestSelect = document.querySelector('.panel-sidebar [name="product-gold-test"]');
                if (goldTestSelect && choicesInstances['product-gold-test']) {
                    goldTestSelect.addEventListener('change', function (event) {
                        const selectedValue = event.target.value;
                        if (selectedValue === '750') {
                            // Zaktualizuj rzeczywiste pole <select>
                            goldTestSelect.value = '750';
                            // $('input[name="white-gold-test"]').val('750');
                            // Wywołaj zdarzenie 'change' dla WPCF7
                            // goldTestSelect.dispatchEvent(new Event('change', { bubbles: true }));

                            // Zaktualizuj wybór w Choices.js dla koloru
                            const colorInstance = choicesInstances['product-color'];
                            if (colorInstance) {
                                colorInstance.setChoiceByValue('Białe złoto');
                            }
                        }
                    });
                }
            }

            $('.product-type-grouped .custom-extra-btn').on('click', function() {
                var colorValue = $(this).data('product-color');
                var productTitle = $(this).data('product-title');
                var newValues = {
                    // 'product-size': sizeValue,
                    'product-color': colorValue
                };

                $.each(newValues, function(selectName, value) {
                    if (choicesInstances[selectName]) {
                        var instance = choicesInstances[selectName];

                        var options = $(instance.passedElement.element).find('option[value="' + value + '"]');
                        if (options.length > 0) {
                            instance.setChoiceByValue(value);
                            $(instance.passedElement.element).val(value).trigger('change');
                            // console.log('Zmieniono wartość w', selectName, 'na', value);
                            $('.form-label--' + selectName).removeClass('hidden');
                            // console.log(value);
                        } else {
                            console.error('Wartość ' + value + ' nie istnieje w select', selectName);
                        }
                    } else {
                        console.error('Nie znaleziono instancji dla selecta o name:', selectName);
                    }
                });
                if (choicesInstances['product-color']) {
                    choicesInstances['product-color'].setChoiceByValue(colorValue);
                }

                $('.form-label--product-parameters span').html(productTitle);
                // $('#product-name').val(productTitle);
                $('.panel-sidebar__inner').removeClass('active');
                $('.panel-sidebar').addClass('active');
                $('.panel-sidebar > header').removeClass('d-none');
                $('.panel-sidebar__content').removeClass('d-none');

                setTimeout(function() {
                    initChoicesListeners();
                }, 100);

            });

            // Obsługa przycisku wyceny (custom-extra-btn) - pobierz wartość rozmiaru wybrany w select na stronie produktu
            $('.woocommerce-variation-add-to-cart').on('click', '.custom-extra-btn', function() {
                var sizeValue = $(this).data('product-size');
                var colorValue = $(this).data('product-color');
                var productTitle = $(this).data('product-title');
                var goldTestValue = $(this).data('product-gold-test');

                // console.log(sizeValue);
                // $('input[name="product-size"]').val('');
                var newValues = {
                    // 'product-size': sizeValue,
                    'product-color': colorValue
                };


                if(document.querySelector('[name="product-color1"]')) {
                    document.querySelector('[name="product-color1"]').value = colorValue;
                }




                $.each(newValues, function(selectName, value) {
                    if (choicesInstances[selectName]) {
                        var instance = choicesInstances[selectName];

                        var options = $(instance.passedElement.element).find('option[value="' + value + '"]');
                        if (options.length > 0) {
                            instance.setChoiceByValue(value);
                            $(instance.passedElement.element).val(value).trigger('change');
                            // console.log('Zmieniono wartość w', selectName, 'na', value);
                            $('.form-label--' + selectName).removeClass('hidden');
                            // console.log(value);
                        } else {
                            console.error('Wartość ' + value + ' nie istnieje w select', selectName);
                        }
                    } else {
                        console.error('Nie znaleziono instancji dla selecta o name:', selectName);
                    }
                });
                // $('input[name="product-size"]').val(sizeValue);

                // Ustawienie wartości w selectach
                if (choicesInstances['product-gold-test']) {
                    choicesInstances['product-gold-test'].setChoiceByValue(goldTestValue);
                }
                if (choicesInstances['product-color']) {
                    choicesInstances['product-color'].setChoiceByValue(colorValue);
                }

                $('.form-label--product-parameters span').html(productTitle);
                // $('#product-name').val(productTitle);
                $('.panel-sidebar').addClass('active');
                $('.panel-sidebar > header').removeClass('d-none');
                $('.panel-sidebar__content').removeClass('d-none');
                $('.panel-sidebar').addClass('active');

                setTimeout(function() {
                    initChoicesListeners();
                }, 100);
            });



            // Reinicjalizacja Choices.js po przesłaniu formularza WPCF7
            document.addEventListener('wpcf7submit', function(event) {
                initializeChoicesForSelects(); // Reinicjalizujemy Choices.js dla selectów po wysłaniu formularza
            });

            // Pobierz wszystkie checkboxy wewnątrz elementów z klasą `.cart__panel`
            // const cartCheckboxes = document.querySelectorAll('.cart__panel .cart__panel-condition input[type="checkbox"]');
            //
            // // Dodaj event listener do każdego checkboxa
            // if (cartCheckboxes.length > 0) {
            //     cartCheckboxes.forEach(function (checkbox) {
            //         checkbox.addEventListener('change', function () {
            //             // Znajdź najbliższy nadrzędny element `.cart__panel`
            //             const cartPanel = this.closest('.cart__panel');
            //
            //             // Sprawdź, czy udało się znaleźć kontener `.cart__panel`
            //             if (cartPanel) {
            //                 // Znajdź element `.cart__panel-response` wewnątrz tego `.cart__panel`
            //                 const cartPanelResponse = cartPanel.querySelector('.cart__panel-response');
            //
            //                 // Jeśli istnieje `.cart__panel-response`, dodaj/usuń klasę `active`
            //                 if (cartPanelResponse) {
            //                     if (this.checked) {
            //                         cartPanelResponse.classList.add('active');
            //                     } else {
            //                         cartPanelResponse.classList.remove('active');
            //                     }
            //                 }
            //             }
            //         });
            //     });
            // }


            function initializeCartCheckboxes() {
                // Znajdź wszystkie checkboxy w koszyku
                const cartCheckboxes = document.querySelectorAll('.cart__panel .cart__panel-condition input[type="checkbox"]');

                // Dodaj event listener do każdego checkboxa
                if (cartCheckboxes.length > 0) {
                    cartCheckboxes.forEach(function (checkbox) {
                        checkbox.addEventListener('change', function () {
                            // Znajdź najbliższy nadrzędny element `.cart__panel`
                            const cartPanel = this.closest('.cart__panel');

                            // Sprawdź, czy udało się znaleźć kontener `.cart__panel`
                            if (cartPanel) {
                                // Znajdź element `.cart__panel-response` wewnątrz tego `.cart__panel`
                                const cartPanelResponse = cartPanel.querySelector('.cart__panel-response');

                                // Jeśli istnieje `.cart__panel-response`, dodaj/usuń klasę `active`
                                if (cartPanelResponse) {
                                    if (this.checked) {
                                        cartPanelResponse.classList.add('active');
                                    } else {
                                        cartPanelResponse.classList.remove('active');
                                    }
                                }
                            }
                        });
                    });
                }
            }
            initializeCartCheckboxes();
            // Ponowna inicjalizacja checkboxów po każdej aktualizacji koszyka WooCommerce (np. po AJAX)
            jQuery(document.body).on('updated_wc_div', function() {
                initializeCartCheckboxes();
            });
            function panelSidebar() {

                //obsługa simplebar w panelu bocznym (listing produktów)

                function initializeSimpleBars() {
                    if($('.panel-sidebar').length > 0) {
                        const panelSidebarContents = document.querySelectorAll('.panel-sidebar__content');

                        panelSidebarContents.forEach(function(content) {
                            const parentPanel = content.closest('.panel-sidebar');
                            const imageHeight = parentPanel.querySelector('.product-image')?.offsetHeight || 0;

                            if(imageHeight) {
                                content.style.height = `${imageHeight - 52}px`;
                            }

                            // Sprawdź czy SimpleBar już istnieje
                            const existingSimpleBar = content.querySelector('.simplebar-content-wrapper');
                            if (!existingSimpleBar) {
                                new SimpleBar(content, {
                                    autoHide: false,
                                    scrollbarMinSize: 6
                                });
                            }
                        });
                    }
                }

                // Inicjalizacja przy starcie
                initializeSimpleBars();

                $('.sidebar-btn').on('click', function() {
                    var productTitle = $(this).data('product-title');
                    var colorValue = $(this).data('product-color');
                    var newValues = {
                        // 'product-size': sizeValue,
                        'product-color': colorValue
                    };

                    $.each(newValues, function(selectName, value) {
                        if (choicesInstances[selectName]) {
                            var instance = choicesInstances[selectName];

                            var options = $(instance.passedElement.element).find('option[value="' + value + '"]');
                            if (options.length > 0) {
                                instance.setChoiceByValue(value);
                                $(instance.passedElement.element).val(value).trigger('change');
                                // console.log('Zmieniono wartość w', selectName, 'na', value);
                                $('.form-label--' + selectName).removeClass('hidden');
                                // console.log(value);
                            } else {
                                console.error('Wartość ' + value + ' nie istnieje w select', selectName);
                            }
                        } else {
                            console.error('Nie znaleziono instancji dla selecta o name:', selectName);
                        }
                    });
                    // $('input[name="product-size"]').val(sizeValue);

                    // Ustawienie wartości w selectach
                    // if (choicesInstances['product-gold-test']) {
                    //     choicesInstances['product-gold-test'].setChoiceByValue(goldTestValue);
                    // }
                    if (choicesInstances['product-color']) {
                        choicesInstances['product-color'].setChoiceByValue(colorValue);
                    }
                    $('.form-label--product-parameters span').html(productTitle);
                    $('.panel-sidebar header').removeClass('d-none');
                    $('.panel-sidebar__inner').removeClass('active');
                    $('.panel-sidebar__content').removeClass('d-none');
                    $('.panel-sidebar').addClass('active');

                    setTimeout(function() {
                        initChoicesListeners();
                    }, 100);
                });

                $('.panel-sidebar').on('click', '.close-panel-btn', function() {
                    var panel = $(this).closest('.panel-sidebar');  // Znajduje najbliższy kontener panelu
                    panel.removeClass('active');
                });

                $(document).click(function(event) {
                    var $panelSidebar = $('.panel-sidebar');

                    // Sprawdź, czy kliknięty element nie znajduje się wewnątrz .panel-sidebar ani nie jest przyciskiem do otwierania panelu
                    if (!$panelSidebar.is(event.target) &&
                        $panelSidebar.has(event.target).length === 0 &&
                        !$('.sidebar-action-trigger-btn, .filter-side-btn, .btn-sidebar').is(event.target)) {
                        // Jeśli kliknięcie było poza .panel-sidebar i przyciskiem, usuń klasę 'active'
                        $panelSidebar.removeClass('active');
                    }
                });

                // Inicjalizacja SimpleBar dla panelu bocznego, jeśli istnieje
                // if ($('.panel-sidebar').length > 0) {
                //     var panelSidebarContent = document.querySelector('.panel-sidebar__content');
                //     new SimpleBar(panelSidebarContent, {
                //         autoHide: false,
                //         scrollbarMinSize: 6
                //     });
                // }

                // Obsługa przycisku zamknięcia panelu
                // $('.panel-sidebar').on('click', '.close-panel-btn', function() {
                //     var panel = $(this).closest('.panel-sidebar');
                //     panel.removeClass('active');
                // });

                // Obsługa zamykania panelu po kliknięciu poza nim
                // $(document).click(function(event) {
                //     var $panelSidebar = $('.panel-sidebar');
                //     if (!$panelSidebar.is(event.target) && $panelSidebar.has(event.target).length === 0 && !$('.sidebar-action-trigger-btn, .filter-side-btn').is(event.target)) {
                //         $panelSidebar.removeClass('active');
                //     }
                // });


            }
            panelSidebar();

            // Funkcja, która sprawdza, czy pole jest wypełnione
            function checkIfFilled($input) {
                if ($input.val() !== '') {
                    $input.closest('.form-row').addClass('filled').removeClass('empty');
                } else {
                    $input.closest('.form-row').addClass('empty').removeClass('filled');
                }
            }

            // Po kliknięciu na label dodajemy klasę focus do najbliższego form-row
            $('body').on('click', 'label', function() {
                var associatedInput = $('#' + $(this).attr('for')); // Znajdź powiązane pole
                if (associatedInput.length) {
                    associatedInput.closest('.form-row').addClass('focused'); // Dodaj klasę 'focused'
                }
            });

            // Monitorujemy zmiany w polach formularza
            $('body').on('input', '.woocommerce-checkout .input-text', function() {
                checkIfFilled($(this));
            });

            // Sprawdzamy, czy pola są wypełnione na starcie (np. w przypadku odświeżenia strony)
            $('.woocommerce-checkout .input-text').each(function() {
                checkIfFilled($(this));
            });
            $('body').on('input', '.register-checkout .input-text', function() {
                checkIfFilled($(this));
            });

            // Sprawdzamy, czy pola są wypełnione na starcie (np. w przypadku odświeżenia strony)
            $('.register-checkout .input-text').each(function() {
                checkIfFilled($(this));
            });


            // Po opuszczeniu pola usuwamy klasę 'focused'
            $('body').on('blur', '.woocommerce-checkout .input-text', function() {
                $(this).closest('.form-row').removeClass('focused');
            });
            // if(document.querySelector('#add_grawering')) {
            //
            //     document.getElementById('add_grawering').addEventListener('change', function() {
            //         var graweringOptions = document.getElementById('grawering-options');
            //         if (this.checked) {
            //             graweringOptions.style.display = 'block';
            //         } else {
            //             graweringOptions.style.display = 'none';
            //         }
            //     });
            // }

        }
    }
    const Woo = {
        init() {
            if($('body.single-product').length > 0) {
                // Pobierz tekst z nagłówka produktu
                var productTitle = $('.product_title').text().trim();

                // Sprawdź czy element istnieje i ma jakąś zawartość
                if(productTitle && $('#product-name').length > 0) {
                    // Ustaw wartość pola
                    $('#product-name').val(productTitle);
                }
            }
            // Funkcja do aktualizacji tekstu przycisku
            function updateAddToCartButton() {
                var $form = $('form.variations_form');
                var $button = $('.single_add_to_cart_button:not(.extra_button)');

                // Funkcja pomocnicza do aktualizacji przycisku na podstawie dostępnej ceny
                function updateButtonPrice() {
                    var $price = $form.find('.woocommerce-variation-price .price');

                    var $firstVariantPrice = $('.custom-variation-list .variation-list-item:not(.stock) .stock-status .stock-status-text .amount').text();
                    // console.log('firstVariantPrice '+$firstVariantPrice);

                    // Sprawdzamy, czy cena jest dostępna
                    if ($price.length && $price.html().trim() !== '' || $firstVariantPrice !== '') {
                        // Cena jest dostępna - aktualizujemy przycisk
                        if($firstVariantPrice) {
                            $button.html($firstVariantPrice + ' - ' + __('addToCart'));
                        }
                        if($price.length) {
                            $button.html($price.html() + ' - ' + __('addToCart'));
                        }
                    } else {
                        // Cena nie jest dostępna, wyświetlamy domyślny tekst
                        if($('.custom-variation-button').attr('data-title') == __('size')) {
                            $button.html(__('selectSize'));
                        }
                        if($('.custom-variation-button').attr('data-title') == __('test')) {
                            $button.html(__('selectTest'));
                        }
                        if($('.custom-variation-button').attr('data-title') == __('measureType')) {
                            $button.html(__('selectMeasureType'));
                        }
                    }
                }

                // Wywołanie przy załadowaniu strony (sprawdzamy od razu, czy wariant ma cenę)
                updateButtonPrice();

                // Nasłuchiwanie na zmiany wariantu
                $form.on('woocommerce_variation_has_changupdateStickyButtoned', function() {
                    // Aktualizujemy przycisk, gdy zmieni się wariant
                    updateButtonPrice();
                });

                // Dodatkowe zabezpieczenie: Aktualizacja przycisku po zmianie wariantu
                $form.on('found_variation', function() {
                    updateButtonPrice();
                });
            }
            if($('.custom-variation-button').length> 0) {
                $('.custom-variation-button').on('click', function() {
                    $(this).parent().toggleClass('active');
                });

            }

            // Nasłuchiwanie na zmianę wariantu
            $('form.variations_form').on('show_variation', function(event, variation) {
                updateAddToCartButton();
            });

            // Resetowanie tekstu przycisku po usunięciu wyboru wariantu
            $('form.variations_form').on('reset_data', function() {
                var $button = $('.single_add_to_cart_button:not(.extra_button)');
                var customVariationButton = $('.custom-variation-button .value .stock-status .stock-status-text .amount').text();
                if($('.custom-variation-button').attr('data-title') == __('size')) {
                    if(customVariationButton !== '') {
                        $button.html(customVariationButton + ' - ' + __('addToCart'));
                    }
                    else {
                        $button.html(__('selectSize'));
                    }
                }
                if($('.custom-variation-button').attr('data-title') == __('test')) {
                    if(customVariationButton !== '') {
                        $button.html(customVariationButton + ' - ' + __('addToCart'));
                    }
                    else {
                        $button.html(__('selectTest'))
                    }
                    // $button.html('Wybierz próbę o');
                }
                if($('.custom-variation-button').attr('data-title') == __('measureType')) {
                    if(customVariationButton !== '') {
                        // $button.html(customVariationButton + ' - Dodaj do koszyka');
                    }
                    else {
                        $button.html(__('selectMeasureType'))
                    }
                    // $button.html('Wybierz próbę o');
                }
            });

            let page = 1;
            let currentColor = ''; // Domyślna wartość koloru

            $('.color-filter').on('click', function() {
                page = 1; // Resetuj stronę do 1 przy zmianie koloru
                currentColor = $(this).data('color');
                loadProducts(currentColor, page);
            });

            $('#load-more').on('click', function() {
                page++;
                loadProducts(currentColor, page);
            });

            function loadProducts(color, page) {
                $.ajax({
                    url: wc_add_to_cart_params.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'filter_products_by_color',
                        color: color,
                        page: page
                    },
                    success: function(response) {
                        if(page === 1) {
                            $('#product-list').html(response);
                            $('#product-list').html(response);
                        } else {
                            $('#product-list').append(response);
                        }
                    }
                });
            }
            document.addEventListener("DOMContentLoaded", function() {
                if( document.querySelector('.featured-products-variants')) {
                    var image = document.querySelector('.section-perfectly_fits_products .col-image img');
                    if(image) {

                        var imageHeight = document.querySelector('.col-image img').offsetHeight;
                        var productList = document.querySelector('.featured-products-variants');

                        // Ustawienie wysokości listy produktów na wysokość zdjęcia
                        productList.style.height = imageHeight - 52 + 'px';

                        // Inicjalizacja SimpleBar tylko na liście produktów
                        new SimpleBar(productList, {
                            autoHide: false,
                            scrollbarMinSize: 6
                        });
                    }
                }
            });

            //modal dla video w produkcie

            function videoModal() {
                // document.addEventListener('DOMContentLoaded', function () {
                var modal = document.getElementById("modal");
                var openModalBtn = document.getElementById("openModalBtn");
                var closeModalBtn = document.querySelector(".close");
                var video = document.getElementById("modalVideo");
                var body = document.querySelector("body");
                if(modal) {
                    // Function to open modal
                    function openModal() {
                        modal.classList.add('show');
                        body.classList.add('video--showing');
                        modal.classList.remove('hide');


                        // Opóźniony start wideo o 1 sekundę
                        setTimeout(function() {
                            video.currentTime = 0; // Reset video time
                            video.play(); // Play video
                        }, 1000); // 1000ms = 1 second
                    }

                    // Function to close modal
                    function closeModal() {
                        modal.classList.add('hide');
                        modal.classList.remove('show');
                        body.classList.remove('video--showing');
                        video.pause(); // Pause video when modal closes

                        // Zakończenie animacji i ukrycie modala po jego zamknięciu
                        setTimeout(function() {
                            modal.style.visibility = 'hidden';
                        }, 400); // Dopasowane do czasu animacji modal-content (0.4s)
                    }

                    // Open modal on button click
                    if(openModalBtn) {

                        openModalBtn.addEventListener('click', function () {
                            modal.style.visibility = 'visible';  // Zmiana widoczności modal przed animacją
                            openModal();
                        });
                    }
                    if(closeModalBtn) {
                        // Close modal on close button click
                        closeModalBtn.addEventListener('click', function () {
                            closeModal();
                        });
                    }

                    // Close modal if clicking outside the modal content
                    window.addEventListener('click', function (event) {
                        if (event.target === modal) {
                            closeModal();
                        }
                    });

                }
                // });
            }
            videoModal();

            $('.filter-side-btn').on('click', function() {
                // var productTitle = $(this).data('product-title');
                // $('.form-label--product-parameters span').html(productTitle);
                $('.panel-sidebar').addClass('active');
                // alert('test');
            });

            $('.btn-sidebar').on('click', function(e) {
                e.preventDefault();
                var dataModal = $(this).attr('data-modal');
                // console.log(dataModal);
                // var productTitle = $(this).data('product-title');
                // $('.form-label--product-parameters span').html(productTitle);
                $('.panel-sidebar').addClass('active');
                if(dataModal) {
                    $('.panel-sidebar__inner[data-modal]').removeClass('active');
                    $('.panel-sidebar__inner[data-modal="'+dataModal+'"]').addClass('active');
                    $('.panel-sidebar > .panel-sidebar__content, .panel-sidebar > header').addClass('d-none');

                }
                // alert('test');
            });

            // Automatyczne otwieranie sidebara na podstawie URL
            function openSidebarFromURL() {
                // Pobierz parametry URL
                var urlParams = new URLSearchParams(window.location.search);
                var hash = window.location.hash;
                
                console.log('openSidebarFromURL wywołana');
                console.log('URL params:', urlParams.toString());
                console.log('Hash:', hash);
                
                // Sprawdź parametr query ?panel=true lub ?panel=nazwa-modala
                if (urlParams.has('panel')) {
                    var panelValue = urlParams.get('panel');
                    console.log('Parametr panel znaleziony:', panelValue);
                    console.log('Liczba elementów .panel-sidebar:', $('.panel-sidebar').length);
                    
                    $('.panel-sidebar').addClass('active');
                    
                    // Jeśli podano konkretny modal (np. ?panel=umow-spotkanie)
                    if (panelValue && panelValue !== 'true' && panelValue !== '1') {
                        var targetModal = $('.panel-sidebar__inner[data-modal="'+panelValue+'"]');
                        console.log('Szukam modala:', panelValue);
                        console.log('Znaleziono elementów z data-modal="'+panelValue+'":', targetModal.length);
                        
                        if (targetModal.length > 0) {
                            $('.panel-sidebar__inner[data-modal]').removeClass('active');
                            targetModal.addClass('active');
                            $('.panel-sidebar > .panel-sidebar__content, .panel-sidebar > header').addClass('d-none');
                            console.log('Modal '+panelValue+' aktywowany');
                        } else {
                            console.warn('Nie znaleziono modala z data-modal="'+panelValue+'"');
                        }
                    }
                }
                
                // Sprawdź hash w URL (np. #panel lub #panel-umow-spotkanie)
                if (hash === '#panel' || hash.startsWith('#panel-')) {
                    console.log('Hash panel znaleziony:', hash);
                    $('.panel-sidebar').addClass('active');
                    
                    // Jeśli hash zawiera nazwę modala (np. #panel-umow-spotkanie)
                    if (hash.startsWith('#panel-')) {
                        var modalName = hash.replace('#panel-', '');
                        var targetModal = $('.panel-sidebar__inner[data-modal="'+modalName+'"]');
                        console.log('Szukam modala z hash:', modalName);
                        console.log('Znaleziono elementów:', targetModal.length);
                        
                        if (targetModal.length > 0) {
                            $('.panel-sidebar__inner[data-modal]').removeClass('active');
                            targetModal.addClass('active');
                            $('.panel-sidebar > .panel-sidebar__content, .panel-sidebar > header').addClass('d-none');
                            console.log('Modal '+modalName+' aktywowany przez hash');
                        }
                    }
                }
            }
            
            // Wywołaj funkcję z małym opóźnieniem, aby DOM był gotowy
            setTimeout(function() {
                openSidebarFromURL();
            }, 100);
            
            // Obsługa zmiany hash w URL (dla linków typu <a href="#sidebar">)
            $(window).on('hashchange', function() {
                openSidebarFromURL();
            });


            // Przy ładowaniu strony
            // $(document).ready(function() {
            //     // Upewnij się, że wszystkie checkboxy są odznaczone na start
            //     $('.checkout-options .option input[type="checkbox"]').prop('checked', false);
            //     $('.checkout-options .option').removeClass('active');
            //
            //     // Zaznacz tylko guest-option
            //     $('.guest-option input[type="checkbox"]').prop('checked', true);
            //     $('.guest-option').addClass('active');
            // });
            // $('#ship-to-different-address-checkbox').parent().addClass('disabled');
            // $('#ship-to-different-address-checkbox').prop('disabled', true);
            // Obsługa zmiany checkboxów
            if($('.checkout-options .option').length > 0) {

                $('.checkout-options .option input[type="checkbox"]').on('change', function(e) {
                    // Jeśli próbujemy odznaczyć aktualnie zaznaczony checkbox, zatrzymaj to
                    if (!$(this).is(':checked')) {
                        e.preventDefault();
                        $(this).prop('checked', true);
                        return;
                    }

                    // Odznacz inne checkboxy
                    $('.checkout-options .option input[type="checkbox"]').not(this).prop('checked', false);

                    // Usuń klasę active tylko z innych elementów
                    $('.checkout-options .option').not($(this).closest('.option')).removeClass('active');

                    // Dodaj klasę active do aktualnego elementu
                    $(this).closest('.option').addClass('active');

                    var dataAccount = $(this).closest('.option').data('account');
                    $('.account-type-div[data-account]').removeClass('active');
                    $('.account-type-div[data-account="'+dataAccount+'"]').addClass('active');

                    if( $('#guest_checkout').is(':checked')) {
                        $('#ship-to-different-address-checkbox').parent().addClass('disabled');
                        $('#ship-to-different-address-checkbox').prop('disabled', true);
                        $('form.woocommerce-checkout').css('display', 'flex');
                    }
                    else {
                        $('#ship-to-different-address-checkbox').parent().removeClass('disabled');
                        $('#ship-to-different-address-checkbox').prop('disabled', false);
                        $('form.woocommerce-checkout').css('display', 'none');

                    }
                });
            }
            else {
                $('#ship-to-different-address-checkbox').parent().removeClass('disabled');
                $('#ship-to-different-address-checkbox').prop('disabled', false);
            }

            // document.addEventListener('DOMContentLoaded', function() {
            //     // Ukrycie domyślnego checkboxa "Stworzyć konstickyCartBtnto?" poniżej formularza
            //     const defaultCreateAccountCheckbox = document.querySelector('.woocommerce-account-fields #createaccount');
            //
            //     if (defaultCreateAccountCheckbox) {
            //         defaultCreateAccountCheckbox.closest('.woocommerce-account-fields').style.display = 'none';
            //     }
            // });
            // document.addEventListener('DOMContentLoaded', function() {
            //     const loginButton = document.getElementById('toggle-login-form');
            //     const loginForm = document.getElementById('checkout-login-form');
            //
            //     if (loginButton && loginForm) {
            //         loginButton.addEventListener('click', function() {
            //             // Przełącz widoczność formularza logowania
            //             if (loginForm.style.display === 'none') {
            //                 loginForm.style.display = 'block';
            //                 loginButton.innerText = 'Zaloguj się';
            //             } else {
            //                 loginForm.style.display = 'none';
            //                 loginButton.innerText = 'Zaloguj się';
            //             }
            //         });
            //     }
            // });

            //obsługa dodawania wiadomości - pakowanie na prezent - koszyk
            // $('#include-sample-message').change(function(){
            //     if ($(this).is(':checked')) {
            //         $('#sample-message-options').show();
            //         console.log('sample checked');
            //     } else {
            //         $('#sample-message-options').hide();
            //         console.log('sample unchecked');
            //     }
            // }).change();
            //
            // $('#include-custom-message').change(function(){
            //     if ($(this).is(':checked')) {
            //         $('#custom-message-box').show();
            //     } else {
            //         $('#custom-message-box').hide();
            //     }
            // }).change();


            const countryField = document.querySelector('select[name="billing_country"]');
            const shippingOptions = document.getElementById('shipping_options');
            const updateButton = document.querySelector('.custom-shipping-section button');

            // Aktualizuj opcje wysyłki po zmianie kraju (billing_country)
            if (countryField) {
                countryField.addEventListener('change', function() {
                    // Użyj standardowego mechanizmu WooCommerce do odświeżania checkout
                    jQuery('body').trigger('update_checkout');
                });
            }

            // Aktualizuj opcje wysyłki po kliknięciu przycisku "Zapisz"
            if (updateButton) {
                updateButton.addEventListener('click', function(e) {
                    e.preventDefault(); // Zatrzymanie przeładowania całego formularza
                    // Użyj standardowego mechanizmu WooCommerce do odświeżania checkout
                    jQuery('body').trigger('update_checkout');
                });
            }

            /*
            function updateShippingOptions() {
                const formData = new FormData();
                formData.append('action', 'update_shipping_method');
                formData.append('country', countryField.value);

                // Pobierz zaznaczoną opcję wysyłki
                const selectedShippingMethod = document.querySelector('input[name="shipping_method[0]"]:checked');
                if (selectedShippingMethod) {
                    formData.append('shipping_method', selectedShippingMethod.value);
                }

                // Wysyłanie żądania AJAX do WooCommerce
                fetch(wc_checkout_params.ajax_url, {
                    method: 'POST',
                    body: formData,
                    credentials: 'same-origin',
                })
                    .then(response => response.text())
                    .then(responseText => {
                        // Aktualizowanie opcji wysyłki bez przeładowania strony
                        shippingOptions.innerHTML = responseText;
                        document.querySelector('.woocommerce-billing-fields #billing_country').value = countryField.value;
                        // Ponowne zaznaczenie opcji wysyłki po zaktualizowaniu
                        if (selectedShippingMethod) {
                            const newlySelected = document.querySelector(`input[value="${selectedShippingMethod.value}"]`);
                            if (newlySelected) {
                                newlySelected.checked = true;
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Błąd aktualizacji opcji wysyłki:', error);
                    });
            }
            */

            function cartCheckout() {
                //sprawdza który checkbox z opcji przed zamówieniem jest dostępny
                // const createAccountCheckbox = document.getElementById('createaccount');
                // const guestCheckoutCheckbox = document.getElementById('guest_checkout');
                //
                // // Event listener dla "Chcę założyć konto"
                // if(createAccountCheckbox && guestCheckoutCheckbox) {
                //
                //     createAccountCheckbox.addEventListener('change', function() {
                //         if (this.checked) {
                //             guestCheckoutCheckbox.checked = false; // Odznacz checkbox "Zamawiam jako gość"
                //         }
                //     });
                //
                //     // Event listener dla "Zamawiam jako gość"
                //     guestCheckoutCheckbox.addEventListener('change', function() {
                //         if (this.checked) {
                //             createAccountCheckbox.checked = false; // Odznacz checkbox "Chcę założyć konto"
                //         }
                //     });
                // }


                const sampleMessageCheckbox = document.getElementById('include_sample_message');
                const sampleMessageOptions = document.getElementById('sample-message-options');
                const customMessageCheckbox = document.getElementById('include_custom_message');
                const customMessageBox = document.getElementById('custom-message-box');

                if(sampleMessageCheckbox && customMessageBox ) {

                    sampleMessageCheckbox.addEventListener('change', function() {
                        if (this.checked) {
                            customMessageCheckbox.checked = false;
                            sampleMessageOptions.style.display = 'block';
                            customMessageBox.style.display = 'none';
                        }
                        else {
                            sampleMessageOptions.style.display = 'none';
                        }
                    });

                    // Event listener dla "Zamawiam jako gość"
                    customMessageCheckbox.addEventListener('change', function() {
                        if (this.checked) {
                            sampleMessageCheckbox.checked = false;
                            customMessageBox.style.display = 'block';
                            sampleMessageOptions.style.display = 'none';
                        }
                        else {
                            customMessageBox.style.display = 'none';
                        }
                    });
                }

                // Monitorujemy zmiany w polach adresu rozliczeniowego
                // $('body').on('input', '#billing_address_1, #billing_postcode, #billing_city, #billing_country, #billing_street, #billing_house_number, #billing_apartment_number',
                //     $.debounce(250, function() {
                //         $('input[name="billing_address_1"]').val($('#billing_address_1').val());
                //         $('input[name="billing_postcode"]').val($('#billing_postcode').val());
                //         $('input[name="billing_city"]').val($('#billing_city').val());
                //         $('input[name="billing_street"]').val($('#billing_street').val());
                //         $('input[name="shipping_house_number"]').val($('#billing_house_number').val());
                //         $('input[name="billing_apartment_number"]').val($('#billing_apartment_number').val());
                //         $('select[name="billing_country"]').val($('#billing_country').val());
                //         $('input[name="shipping_street"]').val($('#billing_street').val());
                //
                //         // Pojedynczy trigger na końcu
                //         $('form.checkout').trigger('update');
                //     }));
                $('body').on('input', '#billing_first_name, #billing_last_name, #billing_address_1, #billing_postcode, #billing_city, #billing_country, #billing_street, #billing_house_number, #billing_apartment_number', function() {
                    let val = $(this).val();
                    let name = $(this).attr('name');

                    if (name === 'terms_acceptance' || $(this).attr('id') === 'terms_acceptance') {
                        return;
                    }

                    let $billingInput = $(`input[name="${name}"]`);
                    if ($billingInput.length && $billingInput.val() !== val) {
                        $billingInput.val(val);
                    }

                    let shippingName = name.replace('billing_', 'shipping_');
                    let $shippingInput = $(`input[name="${shippingName}"]`);

                    if ($shippingInput.length && $shippingInput.val() !== val) {
                        $shippingInput.val(val).trigger('change');
                        $shippingInput.closest('.form-row').addClass('filled');
                    }

                    // Jeśli to select, aktualizuj też selecty
                    if ($(this).is('select')) {
                        let $billingSelect = $(`select[name="${name}"]`);
                        if ($billingSelect.length && $billingSelect.val() !== val) {
                            $billingSelect.val(val);
                        }

                        let $shippingSelect = $(`select[name="${shippingName}"]`);
                        if ($shippingSelect.length && $shippingSelect.val() !== val) {
                            $shippingSelect.val(val).trigger('change');
                        }
                    }
                });

                // $('form.checkout').on('submit', function(e) {
                //     // Sprawdź czy checkbox terms jest zaznaczony
                //     if (!$('#terms_acceptance').is(':checked')) {
                //         // Zatrzymaj domyślne zachowanie i AJAX
                //         e.preventDefault();
                //         e.stopPropagation();
                //
                //         // Pokaż komunikat o błędzie
                //         if ($('.terms-error').length === 0) {
                //             $('#terms_acceptance').after('<div class="terms-error" style="color: red;">Proszę zaakceptować warunki</div>');
                //         }
                //
                //         // Przewiń do checkboxa
                //         $('html, body').animate({
                //             scrollTop: $('#terms_acceptance').offset().top - 100
                //         }, 500);
                //
                //         return false;
                //     }
                // });
                // // Po kliknięciu przycisku Zapisz, przelicz zamówienie
                $('.custom-shipping-section button').on('click', function() {
                    $('body').trigger('update_checkout');
                });


                // Funkcja do zapisywania wartości i ukrywania pól
                function saveShippingFields() {
                    $('.custom-shipping-section .form-row').each(function() {
                        var input = $(this).find('input, select'); // Znajdujemy inputy i selecty

                        if(input.hasClass('country_select')) {
                            var fieldValue = input.find('option:selected').text(); // Pobieramy tekst z selecta
                        }

                        else {
                            var fieldValue = input.val(); // Pobieramy wartość z inputa
                            // if(input.hasClass('shipping_method')) {
                            //     var inputId = input.attr('id');
                            // }
                        }
                        var fieldLabel = $(this).find('label');
                        // Pobierz tekst bez elementu <abbr> (który zawiera gwiazdkę)
                        var fieldLabelText = fieldLabel.contents().filter(function() {
                            return this.nodeType === 3; // Pobiera tylko węzły tekstowe
                        }).text().trim(); // Usuwa spacje przed i po tekście
                        var inputWrapper = $(this).find('.woocommerce-input-wrapper');

                        if(fieldValue !== '') {

                            // Tworzymy nowy div, który wyświetli nazwę pola i wartość
                            var displayDiv = $('<div class="shipping-value" data-id="'+inputId+'"><strong>' + fieldLabelText + ':</strong> ' + fieldValue + '</div>');
                        }

                        // Ukryjemy pole edytowalne
                        input.hide();
                        fieldLabel.hide();
                        inputWrapper.hide();

                        // Jeśli pole nie istnieje, dodajemy wyświetlanie wartości
                        if ($(this).find('.shipping-value').length === 0) {
                            $(this).append(displayDiv);
                        }
                    });

                    // Pobranie wybranej metody dostawy
                    var shippingOptions = $('#shipping_options');
                    var chosenMethod = $('input[name="shipping_method[0]"]:checked').closest('li').find('label').text();
                    shippingOptions.hide();
                    var inputId = $('input[name="shipping_method[0]"]:checked').attr('id');
                    // Wyświetlenie wybranej metody dostawy
                    $('#shipping-method-text').text(chosenMethod);
                    $('#shipping-method-text').attr('id', inputId);
                    $('#selected-shipping-method').show(); // Pokażemy sekcję z wybraną metodą dostawy



                    // Pokaż przycisk Zmień
                    $('#change-shipping-button').show();

                    // Ukryj przycisk Zapisz
                    $('#save-shipping-button').hide();
                }

                // Funkcja do przywracania pól do edycji
                function editShippingFields() {
                    $('.custom-shipping-section .form-row').each(function() {
                        var input = $(this).find('input, select'); // Znajdujemy inputy i selecty
                        var fieldLabel = $(this).find('label');
                        var inputWrapper = $(this).find('.woocommerce-input-wrapper');
                        input.show(); // Pokażemy pole do edycji
                        fieldLabel.show();
                        inputWrapper.show();
                        // Usuwamy wyświetlaną wartość
                        $(this).find('.shipping-value').remove();
                    });

                    var shippingOptions = $('#shipping_options');
                    shippingOptions.show();

                    // Pokaż przycisk Zapisz
                    $('#save-shipping-button').show();

                    // Ukryj przycisk Zmień
                    $('#change-shipping-button').hide();
                }

                // Obsługa kliknięcia na przycisk Zapisz
                $('#save-shipping-button').on('click', function(e) {
                    e.preventDefault(); // Zatrzymanie domyślnego zachowania
                    saveShippingFields(); // Zapisujemy pola
                    $('.col-shipping').addClass('saved-fields');
                    $('body').trigger('update_checkout');
                });

                // Obsługa kliknięcia na przycisk Zmień
                $('#change-shipping-button').on('click', function(e) {
                    e.preventDefault(); // Zatrzymanie domyślnego zachowania
                    editShippingFields(); // Przywracamy pola do edycji
                    $('.col-shipping').removeClass('saved-fields');
                    $('body').trigger('update_checkout');
                });
                // Function to check shipping method
                function checkShippingMethod() {
                    var selected = $('input[name^="shipping_method"]:checked').val();

                    // Hide all pickup info
                    $('.pickup-info').hide();

                    // If local pickup is selected, show info
                    if (selected && selected.includes('local_pickup')) {
                        $('.pickup-info').show();
                    }
                }

                // Check on page load
                checkShippingMethod();

                // Check on method change
                $('body').on('change', 'input[name^="shipping_method"]', function() {
                    checkShippingMethod();
                    $(document.body).trigger('update_checkout');
                });

                // Check on checkout update
                $(document.body).on('updated_checkout', function() {
                    checkShippingMethod();
                });
                // $('#createaccount').on('click', function(e) {
                //     $('#register-step').show();
                //     $('#checkout-login-form').hide();
                // });
                // $('#guest_checkout').on('click', function(e) {
                //     $('#register-step').hide();
                //     $('#checkout-login-form').hide();
                // });

                // $('#register-form').on('submit', function(e) {
                //     e.preventDefault();
                //
                //     var $form = $(this);
                //     var $submitButton = $form.find('button[type="submit"]');
                //     var $messageContainer = $('#message-container'); // Kontener na wiadomości (dodaj go w HTML)
                //
                //     $submitButton.prop('disabled', true);
                //
                //     $.ajax({
                //         url: themeParams.ajax_url,  // Zmiana z themeParams.ajaxurl na themeParams.ajax_url
                //         type: 'POST',
                //         data: {
                //             action: 'register_user',
                //             nonce: themeParams.checkout.nonce,
                //             email: $('#reg_email').val(),
                //             password: $('#reg_password').val(),
                //             password_confirm: $('#reg_password_confirm').val()
                //         },
                //         success: function(response) {
                //             console.log(response.data.message);
                //             // Obsługa odpowiedzi
                //             $('#message-container').html(response.data.message);
                //             if(response.success) {
                //                 // alert('błąd!');
                //                 console.log(response.data.email);
                //                 $('input[name="billing_email"]').val(response.data.email);
                //             }
                //             else {
                //                 // console.log(data.email);
                //             }
                //         },
                //         error: function() {
                //             showMessage('error', 'Wystąpił błąd. Spróbuj ponownie.');
                //         },
                //         complete: function() {
                //             $submitButton.prop('disabled', false);
                //         }
                //     });
                //
                //
                //     function showMessage(type, message) {
                //         // Wstawienie wiadomości do kontenera na stronie
                //         $messageContainer.html('<div class="' + type + '">' + message + '</div>').fadeIn();
                //
                //         // Opcjonalnie ukrycie wiadomości po 5 sekundach
                //         setTimeout(function() {
                //             $messageContainer.fadeOut();
                //         }, 5000);
                //     }
                // });
                $('#register-form').on('submit', function(e) {
                    e.preventDefault();

                    var $form = $(this);
                    var $submitButton = $form.find('button[type="submit"]');

                    // Usuń poprzednie komunikaty błędów/sukcesu
                    $('.woocommerce-error, .woocommerce-message').remove();

                    $.ajax({
                        url: themeParams.ajax_url,
                        type: 'POST',
                        data: {
                            action: 'register_checkout_user',
                            email: $('#reg_email').val(),
                            password: $('#reg_password').val(),
                            password_confirm: $('#reg_password_confirm').val(), // dodane potwierdzenie hasła
                            security: $('#_wpnonce').val()
                        },
                        success: function(response) {
                            // console.log('Success response:', response);
                            if (response.success) {
                                $form.slideUp();
                                // Wyświetl komunikat sukcesu
                                $form.after(response.data); // używamy response.data zamiast własnego HTML

                                setTimeout(function(){
                                    window.location.reload();
                                }, 1500);
                            } else {
                                // Wyświetl komunikat błędu
                                $form.before(response.data); // używamy response.data zamiast własnego HTML
                            }
                        },
                        error: function(xhr, status, error) {
                            console.log('Error:', {
                                xhr: xhr,
                                status: status,
                                error: error
                            });
                            $form.before('<div class="woocommerce-error">Wystąpił błąd podczas rejestracji. Spróbuj ponownie.</div>');
                        }
                    });
                });
// Nasłuchuj zdarzenia zastosowania kuponu


                // Regex dla walidacji emaila
                const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

                // Funkcja do wyświetlania błędów
                function showError(field, message) {
                    const errorDiv = field.next('.validation-error');
                    if (!errorDiv.length) {
                        $('<div class="validation-error" style="color: red; font-size: 0.9em;"></div>').insertAfter(field);
                    }
                    field.next('.validation-error').text(message);
                }

                // Funkcja do usuwania komunikatów o błędach
                function removeError(field) {
                    field.next('.validation-error').remove();
                }

                // Walidacja numeru telefonu - WYŁĄCZONA
                // Można wpisać dowolny numer telefonu

                // Walidacja emaila
                $('#billing_email').on('input', function() {
                    const email = $(this).val();

                    if (email.length > 0) {
                        if (!emailRegex.test(email)) {
                            showError($(this), __('invalidEmail'));
                            $(this).addClass('invalid');
                        } else {
                            removeError($(this));
                            $(this).removeClass('invalid');
                        }
                    } else {
                        removeError($(this));
                        $(this).removeClass('invalid');
                    }
                });


            }
            cartCheckout();


        }
    }
    const Filters = {
        init() {
            var selectedSizes = []; // Tablica przechowująca wybrane rozmiary
            var selectedSort = ''; // Zmienna przechowująca wybraną opcję sortowania
            var selectedColor = ''; // Zmienna przechowująca wybrany kolor złota

            // Funkcja do aktualizacji liczby wyników na podstawie zaznaczonych filtrów
            function updateProductCount() {
                var categoryID = $('.products__wrapper').data('category-id'); // Pobierz ID kategorii z atrybutu data
                // var selectedColor = $('#gold-color-filter .gold-color-btn').hasClass('active') ?
                //     $('#gold-color-filter .gold-color-btn.active').attr('data-color') : '';


                // console.log("Aktualizacja wyników: ");
                // console.log("Wybrane rozmiary: ", selectedSizes);
                // console.log("Wybrany kolor: ", selectedColor);
                // console.log("Wybrana kategoria: ", categoryID);

                // Wysłanie zapytania AJAX do serwera, aby uzyskać liczbę produktów
                $.ajax({
                    url: themeParams.ajax_url, // WordPress AJAX URL
                    type: 'GET',
                    data: {
                        action: 'get_filtered_product_count', // Nazwa akcji AJAX
                        category: categoryID, // Dodaj ID kategorii do zapytania
                        gold_color: selectedColor,
                        sizes: selectedSizes, // Przekazujemy tablicę wybranych rozmiarów
                        sort_by: selectedSort // Przekazujemy wybrane sortowanie
                    },
                    beforeSend: function() {
                        $('body').addClass('loading');
                        $('.filter-output__wrapper').removeClass('active');
                    },
                    success: function(response) {

                        // console.log("Odpowiedź z serwera: ", response);
                        var data = JSON.parse(response);

                        // Zaktualizuj przycisk #filter-btn o liczbę wyników
                        if (data.product_count) {
                            $('#filter-btn').html(__('seeResults') + ' (' + data.product_count + ')');
                        } else {
                            $('#filter-btn').html(__('noResults'));
                        }
                    },
                    error: function(xhr, status, error) {
                        console.log('Błąd AJAX: ' + error); // Logowanie błędów w konsoli
                    },
                    complete: function() {
                        $('body').removeClass('loading');
                        $('.filter-output__wrapper').addClass('active');
                    }
                });
            }
            $('.current-gold-color').on('click', function(e) {
                e.preventDefault();
                $(this).parent().toggleClass('active');
            });
            // Obsługa kliknięcia przycisku wyboru koloru - szybkie filtrowanie po kolorze
            $('#gold-color-filter .gold-color-btn').on('click', function(e) {
                e.preventDefault();

                selectedColor = $(this).data('color'); // Pobierz wybrany kolor
                // console.log('selected '+selectedColor);
                var categoryID = $('.products__wrapper').data('category-id'); // Pobierz ID kategorii z atrybutu data
                $('#gold-color-filter .gold-color-btn').removeClass('active');
                $(this).addClass('active');
                $('.panel-sidebar__content--filters .gold-color-filter .gold-color-btn').removeClass('active');
                $('.panel-sidebar__content--filters .gold-color-filter .gold-color-btn[data-color="'+selectedColor+'"]').addClass('active');
                $('.gold-color-filter__wrapper').removeClass('active');
                $('.current-gold-color').html($(this).html());
                updateProductCount();
                // AJAX request
                $.ajax({
                    url: themeParams.ajax_url, // WordPress AJAX URL
                    type: 'GET',
                    data: {
                        action: 'filter_products_by_sort', // Nazwa akcji
                        gold_color: selectedColor, // Wybrany kolor złota
                        category: categoryID, // Dodaj ID kategorii do zapytania
                        sizes: selectedSizes // Przekazujemy tablicę wybranych rozmiarów

                    },
                    success: function(response) {
                        var data = JSON.parse(response); // Parsujemy odpowiedź jako JSON

                        if (data.status === 'success') {
                            // Zastąp produkty nową zawartością
                            var newContent = $(data.html).hide(); // Ukryj nową zawartość przed wstawieniem
                            $('.products__wrapper').html(newContent);
                            newContent.fadeIn('slow'); // Dodaj animację fadeIn po wstawieniu

                            // Zaktualizuj liczbę produktów w elemencie .output-count
                            $('.output-count').text('('+data.product_count + ')');
                            if(data.product_count !== '') {
                                $('.filter-output__wrapper').addClass('active');
                            }
                            else {
                                $('.filter-output__wrapper').removeClass('active');
                            }

                        } else {
                            console.log('Błąd: ' + data.message);
                        }
                    },
                    error: function(xhr, status, error) {
                        console.log('Błąd AJAX: ' + error); // Logowanie błędów w konsoli
                    }
                });
            });
            $('.product-view__wrapper .product-view-btn').on('click', function(e) {
                $('.product-view-btn').removeClass('active');
                $(this).addClass('active');
                $('.products__wrapper').attr('data-view', $(this).data('view'));
            });

            // Kliknięcie przycisku sortowania
            $('.sort-option').on('click', function(e) {
                e.preventDefault();
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    selectedSort = ''; // Usuń sortowanie
                } else {
                    $('.sort-option').removeClass('active'); // Odznacz inne sortowania
                    $(this).addClass('active');

                    selectedSort = $(this).data('sort'); // Ustaw nowe sortowanie
                }
                console.log('Wybrane sortowanie:', selectedSort);
                console.log('Wybrane rozmiary:', selectedSizes);
                console.log('Wybrany kolor:', selectedColor);
                // updateProductCount();
            });
            $('.gold-color-filter.filter-btn-container .gold-color-btn').on('click', function(e) {
                e.preventDefault();
                selectedColor = $(this).data('color');
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $('#gold-color-filter .gold-color-btn').removeClass('active');
                    selectedColor = ''; // Usuń filtr koloru złota
                } else {
                    $('.gold-color-filter.filter-btn-container .gold-color-btn').removeClass('active'); // Odznacz inne kolory
                    $('#gold-color-filter .gold-color-btn').removeClass('active');
                    $(this).addClass('active');
                    $('#gold-color-filter .gold-color-btn[data-color="'+selectedColor+'"]').addClass('active');
                    selectedColor = $(this).data('color'); // Ustaw nowy kolor
                }
                // Aktualizuj liczbę wyników po zmianie rozmiaru
                updateProductCount();
            });
            // var selectedSizes = []; // Tablica przechowująca wybrane rozmiary

            // Kliknięcie na przycisk rozmiaru
            $('.size-filter-buttons').on('click', '.size-option', function(e) {
                e.preventDefault();

                var size = $(this).data('size');

                // Zaznacz lub odznacz rozmiar
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    // Usuń rozmiar z tablicy, jeśli został odznaczony
                    selectedSizes = selectedSizes.filter(function(value) {
                        return value !== size;
                    });
                } else {
                    $(this).addClass('active');
                    // Dodaj rozmiar do tablicy
                    selectedSizes.push(size);
                }

                // Zlicz liczbę zaznaczonych elementów i zaktualizuj tekst w .accordion-count
                $('.accordion-count').html('(' + selectedSizes.length + ')');
                // Aktualizuj liczbę wyników po zmianie rozmiaru
                updateProductCount();
            });

            // Kliknięcie przycisku resetowania filtrów
            $('#reset-btn').on('click', function(e) {
                e.preventDefault();

                // Resetowanie wybranych filtrów
                selectedSizes = [];
                selectedSort = '';
                selectedColor = '';

                // Usunięcie klas 'active' z przycisków
                $('.size-option').removeClass('active');
                $('.sort-option').removeClass('active');
                $('.gold-color-filter .gold-color-btn').removeClass('active');

                // Zaktualizowanie tekstu przycisku "Filtruj"
                $('#filter-btn').html(__('seeResults'));
                $('.filter-output__wrapper').removeClass('active');
                // Wywołanie funkcji updateProductCount, aby przywrócić domyślne wyniki
                updateProductCount();
            });

            // Kliknięcie przycisku "Filtruj"
            $('#filter-btn').on('click', function(e) {
                e.preventDefault();
                var categoryID = $('.products__wrapper').data('category-id'); // Pobierz ID kategorii z atrybutu data
                $('.panel-sidebar').removeClass('active');

                // AJAX request do serwera, przesyłanie wybranej opcji sortowania
                $.ajax({
                    url: themeParams.ajax_url, // WordPress AJAX URL
                    type: 'GET',
                    data: {
                        action: 'filter_products_by_sort', // Nazwa akcji
                        sort_by: selectedSort, // Przekazujemy wybraną opcję sortowania
                        category: categoryID, // Dodaj ID kategorii do zapytania
                        gold_color: selectedColor,
                        sizes: selectedSizes // Przekazujemy tablicę wybranych rozmiarów
                    },
                    success: function(response) {
                        // console.log(response); // Zobacz, co faktycznie zwraca serwer
                        try {
                            var data = JSON.parse(response);
                            // Zastąp produkty nową zawartością
                            var newContent = $(data.html).hide(); // Ukryj nową zawartość przed wstawieniem
                            $('.products__wrapper').html(newContent);
                            newContent.fadeIn('slow'); // Dodaj animację fadeIn po wstawieniu

                            // Zaktualizuj przycisk #filter-btn o liczbę wyników
                            if (data.product_count) {
                                $('#filter-btn').html(__('seeResults') + ' (' + data.product_count + ')');
                                $('.output-count').html('(' + data.product_count + ')');
                                $('.filter-output__wrapper').addClass('active');
                            } else {
                                // $('#filter-btn').html('Brak wyników');
                                $('.filter-output__wrapper').removeClass('active');
                            }
                        } catch (e) {
                            console.log("Błąd przy parsowaniu odpowiedzi JSON: ", e);
                        }
                    },
                    error: function(xhr, status, error) {
                        console.log('Błąd AJAX: ' + error); // Logowanie błędów w konsoli
                    }
                });
            });
        }
    }

    const Main = {
        init() {

            const body = document.body;
            const nav = document.querySelector(".site-header > .col-full");
            const menu = document.querySelector(".secondary-navigation");
            const scrollUp = "scroll-up";
            const scrollDown = "scroll-down";
            let lastScroll = 0;
            if($(window).width() > 767) {

                window.addEventListener("scroll", () => {
                    const currentScroll = window.pageYOffset;
                    if (currentScroll <= 0) {
                        body.classList.remove(scrollUp);
                        return;
                    }
                    if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
                        // down
                        body.classList.remove(scrollUp);
                        body.classList.add(scrollDown);

                        body.classList.remove('nav-expanded');
                    } else if (
                        currentScroll < lastScroll &&
                        body.classList.contains(scrollDown)
                    ) {
                        // up
                        body.classList.remove(scrollDown);
                        body.classList.add(scrollUp);
                    }
                    lastScroll = currentScroll;
                });
            }
            else {

            }
            $('.btn.show-all').on('click', function(e) {
                e.preventDefault();
                $('.fair__list .list__item.hidden').css("display", "flex").hide().fadeIn();
                $('.fair__list .list__item.hidden').removeClass('hidden');
                $(this).hide();
            })
            const accordionBtns = document.querySelectorAll(".accordion-button");

            accordionBtns.forEach((accordion) => {
                accordion.onclick = function () {
                    // Close all other accordions first
                    accordionBtns.forEach((otherAccordion) => {
                        if (otherAccordion !== this) {
                            otherAccordion.parentNode.classList.remove("is-open");
                            let otherContent = otherAccordion.nextElementSibling;
                            otherContent.style.maxHeight = null;
                        }
                    });

                    // Toggle the clicked accordion
                    this.parentNode.classList.toggle("is-open");

                    let content = this.nextElementSibling;

                    if (content.style.maxHeight) {
                        // If the accordion is open, close it
                        content.style.maxHeight = null;
                    } else {
                        // If the accordion is closed, open it
                        content.style.maxHeight = content.scrollHeight + "px";
                    }
                };
            });
            if($(window).width() > 767) {
                var lightbox = new SimpleLightbox('.accordion.desktop-only .accordion-content a', { scrollZoom: false, focus: false});
            }
            else {
                var lightbox = new SimpleLightbox('.accordion.mobile-only .accordion-content a', { scrollZoom: false, focus: false});

            }

            MenuNavbar.init();
            Sliders.init();
            Forms.init();
            Woo.init();
            Filters.init();


            console.log('Theme initialized successfully.');

        }
    }
    Main.init();
})(jQuery);

// jQuery.noConflict();
// jQuery(document).ready(function($) {
//     $('.custom-select').each(function() {
//         new SlimSelect({
//             select: this
//         });
//     });
// });
